import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = window.location.origin || process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Industry-Specific Content Categories (Dynamic based on user's industry)
const INDUSTRY_CONTENT_CATEGORIES = {
  'Food & Restaurant': {
    title: 'Cuisine Categories',
    categories: {
  continental: {
    name: 'Continental',
    icon: '🍽️',
    items: [
      { id: 1, name: 'Grilled Steak', prompt: 'Perfectly grilled steak with char marks and juices' },
      { id: 2, name: 'Caesar Salad', prompt: 'Fresh Caesar salad with crispy croutons and parmesan' },
      { id: 3, name: 'French Fries', prompt: 'Golden crispy french fries with perfect seasoning' },
      { id: 4, name: 'Fish & Chips', prompt: 'Crispy battered fish with thick-cut chips' },
      { id: 5, name: 'Roast Chicken', prompt: 'Golden roasted chicken with herbs and vegetables' },
      { id: 6, name: 'Mashed Potatoes', prompt: 'Creamy mashed potatoes with butter and herbs' },
      { id: 7, name: 'Beef Wellington', prompt: 'Elegant beef wellington with golden pastry' },
      { id: 8, name: 'Grilled Salmon', prompt: 'Perfectly grilled salmon fillet with lemon' },
      { id: 9, name: 'Lobster', prompt: 'Fresh lobster with melted butter' },
      { id: 10, name: 'Club Sandwich', prompt: 'Triple-decker club sandwich with layers' },
      { id: 11, name: 'Pancakes', prompt: 'Fluffy pancakes stacked with syrup and butter' },
      { id: 12, name: 'Waffles', prompt: 'Golden Belgian waffles with toppings' },
      { id: 13, name: 'Omelette', prompt: 'Fluffy omelette with fresh ingredients' },
      { id: 14, name: 'Hash Browns', prompt: 'Crispy golden hash browns' },
      { id: 15, name: 'Croissant', prompt: 'Buttery flaky croissant with layers' },
      { id: 16, name: 'Quiche', prompt: 'French quiche with savory filling' },
      { id: 17, name: 'Soup', prompt: 'Creamy soup in elegant bowl with garnish' },
      { id: 18, name: 'Baked Potato', prompt: 'Loaded baked potato with toppings' },
      { id: 19, name: 'Grilled Veggies', prompt: 'Colorful grilled vegetables arrangement' },
      { id: 20, name: 'Cheese Platter', prompt: 'Gourmet cheese board with varieties' }
    ]
  },
  indopak: {
    name: 'Indo-Pak',
    icon: '🍛',
    items: [
      { id: 1, name: 'Biryani', prompt: 'Aromatic biryani with fragrant basmati rice and tender meat' },
      { id: 2, name: 'Nihari', prompt: 'Slow-cooked Nihari with rich gravy and garnish' },
      { id: 3, name: 'Karahi', prompt: 'Sizzling karahi in traditional wok with spices' },
      { id: 4, name: 'Haleem', prompt: 'Rich creamy haleem with garnishes' },
      { id: 5, name: 'Kebab', prompt: 'Juicy grilled kebabs with char marks' },
      { id: 6, name: 'Tandoori Chicken', prompt: 'Red tandoori chicken with yogurt marinade' },
      { id: 7, name: 'Butter Chicken', prompt: 'Creamy butter chicken with rich gravy' },
      { id: 8, name: 'Palak Paneer', prompt: 'Spinach curry with paneer cubes' },
      { id: 9, name: 'Dal Makhani', prompt: 'Creamy black lentil dal with butter' },
      { id: 10, name: 'Samosa', prompt: 'Golden crispy samosas with chutney' },
      { id: 11, name: 'Pakora', prompt: 'Crispy vegetable pakoras in basket' },
      { id: 12, name: 'Naan', prompt: 'Fresh tandoori naan bread with butter' },
      { id: 13, name: 'Paratha', prompt: 'Layered paratha with crispy edges' },
      { id: 14, name: 'Chaat', prompt: 'Colorful street chaat with chutneys' },
      { id: 15, name: 'Jalebi', prompt: 'Sweet orange jalebis in syrup' },
      { id: 16, name: 'Gulab Jamun', prompt: 'Soft gulab jamun in sugar syrup' },
      { id: 17, name: 'Kheer', prompt: 'Creamy rice kheer with nuts and saffron' },
      { id: 18, name: 'Lassi', prompt: 'Thick creamy lassi in traditional glass' },
      { id: 19, name: 'Chai', prompt: 'Hot tea in traditional cup with steam' },
      { id: 20, name: 'Thali', prompt: 'Complete Indian thali with multiple dishes' }
    ]
  },
  chinese: {
    name: 'Chinese',
    icon: '🥢',
    items: [
      { id: 1, name: 'Fried Rice', prompt: 'Colorful fried rice with vegetables and egg' },
      { id: 2, name: 'Chow Mein', prompt: 'Stir-fried noodles with vegetables' },
      { id: 3, name: 'Sweet & Sour', prompt: 'Sweet and sour chicken with sauce' },
      { id: 4, name: 'Spring Rolls', prompt: 'Crispy golden spring rolls' },
      { id: 5, name: 'Dumplings', prompt: 'Steamed dumplings in bamboo basket' },
      { id: 6, name: 'Kung Pao Chicken', prompt: 'Spicy kung pao chicken with peanuts' },
      { id: 7, name: 'Mapo Tofu', prompt: 'Spicy mapo tofu with red chili oil' },
      { id: 8, name: 'Hot Pot', prompt: 'Bubbling hot pot with ingredients' },
      { id: 9, name: 'Peking Duck', prompt: 'Crispy Peking duck with pancakes' },
      { id: 10, name: 'Dim Sum', prompt: 'Variety of dim sum in steamer baskets' },
      { id: 11, name: 'Wonton Soup', prompt: 'Clear wonton soup with floating wontons' },
      { id: 12, name: 'Chop Suey', prompt: 'Vegetable chop suey with sauce' },
      { id: 13, name: 'Orange Chicken', prompt: 'Glazed orange chicken with citrus' },
      { id: 14, name: 'Mongolian Beef', prompt: 'Tender Mongolian beef with scallions' },
      { id: 15, name: 'Egg Rolls', prompt: 'Crispy egg rolls with dipping sauce' },
      { id: 16, name: 'Szechuan Prawns', prompt: 'Spicy Szechuan prawns with peppers' },
      { id: 17, name: 'Bok Choy', prompt: 'Stir-fried bok choy with garlic' },
      { id: 18, name: 'Fortune Cookies', prompt: 'Golden fortune cookies arranged' },
      { id: 19, name: 'Bao Buns', prompt: 'Fluffy steamed bao buns with filling' },
      { id: 20, name: 'Congee', prompt: 'Creamy rice congee with toppings' }
    ]
  },
  italian: {
    name: 'Italian',
    icon: '🇮🇹',
    items: [
      { id: 1, name: 'Margherita Pizza', prompt: 'Classic margherita pizza with fresh basil' },
      { id: 2, name: 'Carbonara', prompt: 'Creamy spaghetti carbonara with bacon' },
      { id: 3, name: 'Lasagna', prompt: 'Layered lasagna with melted cheese' },
      { id: 4, name: 'Risotto', prompt: 'Creamy risotto with parmesan' },
      { id: 5, name: 'Bruschetta', prompt: 'Toasted bruschetta with tomatoes and basil' },
      { id: 6, name: 'Tiramisu', prompt: 'Elegant tiramisu dessert with cocoa' },
      { id: 7, name: 'Caprese Salad', prompt: 'Fresh caprese with mozzarella and tomatoes' },
      { id: 8, name: 'Ravioli', prompt: 'Handmade ravioli with sauce' },
      { id: 9, name: 'Penne Arrabiata', prompt: 'Spicy penne pasta with tomato sauce' },
      { id: 10, name: 'Osso Buco', prompt: 'Braised veal osso buco with risotto' },
      { id: 11, name: 'Minestrone', prompt: 'Hearty minestrone soup with vegetables' },
      { id: 12, name: 'Panna Cotta', prompt: 'Smooth panna cotta with berry sauce' },
      { id: 13, name: 'Gelato', prompt: 'Colorful gelato scoops in cup' },
      { id: 14, name: 'Focaccia', prompt: 'Herb-topped focaccia bread' },
      { id: 15, name: 'Calzone', prompt: 'Folded calzone with melted cheese' },
      { id: 16, name: 'Gnocchi', prompt: 'Potato gnocchi with sauce' },
      { id: 17, name: 'Saltimbocca', prompt: 'Veal saltimbocca with sage' },
      { id: 18, name: 'Arancini', prompt: 'Golden fried arancini rice balls' },
      { id: 19, name: 'Pesto Pasta', prompt: 'Pasta with green pesto sauce' },
      { id: 20, name: 'Cannoli', prompt: 'Sicilian cannoli with ricotta filling' }
    ]
  },
  middleeastern: {
    name: 'Middle Eastern',
    icon: '🧆',
    items: [
      { id: 1, name: 'Shawarma', prompt: 'Juicy chicken shawarma wrap with sauces' },
      { id: 2, name: 'Falafel', prompt: 'Crispy falafel balls with tahini' },
      { id: 3, name: 'Hummus', prompt: 'Creamy hummus with olive oil drizzle' },
      { id: 4, name: 'Kebab Platter', prompt: 'Mixed kebab platter with rice and salad' },
      { id: 5, name: 'Tabbouleh', prompt: 'Fresh tabbouleh salad with parsley' },
      { id: 6, name: 'Fattoush', prompt: 'Colorful fattoush with crispy bread' },
      { id: 7, name: 'Baba Ganoush', prompt: 'Smoky baba ganoush with pita' },
      { id: 8, name: 'Mansaf', prompt: 'Traditional mansaf with lamb and rice' },
      { id: 9, name: 'Maqluba', prompt: 'Upside-down maqluba with vegetables' },
      { id: 10, name: 'Kunafa', prompt: 'Sweet kunafa dessert with cheese' },
      { id: 11, name: 'Baklava', prompt: 'Layered baklava with honey and pistachios' },
      { id: 12, name: 'Labneh', prompt: 'Thick labneh with olive oil and herbs' },
      { id: 13, name: 'Manakish', prompt: 'Zaatar manakish flatbread' },
      { id: 14, name: 'Kibbeh', prompt: 'Golden fried kibbeh with bulgur' },
      { id: 15, name: 'Moutabal', prompt: 'Creamy moutabal eggplant dip' },
      { id: 16, name: 'Grilled Halloumi', prompt: 'Grilled halloumi cheese with char marks' },
      { id: 17, name: 'Dolma', prompt: 'Stuffed grape leaves arranged' },
      { id: 18, name: 'Kofta', prompt: 'Spiced kofta meatballs with sauce' },
      { id: 19, name: 'Arabic Coffee', prompt: 'Traditional Arabic coffee in dallah pot' },
      { id: 20, name: 'Mixed Grill', prompt: 'Middle Eastern mixed grill platter' },
      { id: 21, name: 'Lamb Mandi', prompt: 'Slow-cooked lamb mandi with fragrant spiced rice and garnish' },
      { id: 22, name: 'Chicken Madghoot', prompt: 'Emirati chicken madghoot pressure-cooked with aromatic spiced rice' },
      { id: 23, name: 'Chicken Al Faham', prompt: 'Charcoal-grilled chicken al faham with smoky Arabian marinade' },
      { id: 24, name: 'Mutton Mandi', prompt: 'Tender mutton mandi served with Peshawar rice and special sauce' },
      { id: 25, name: 'Samboosa', prompt: 'Crispy golden samboosa stuffed with spiced meat filling' },
      { id: 26, name: 'Shakshuka', prompt: 'Eggs poached in rich spiced tomato sauce in cast iron skillet' }
    ]
  },
  asian: {
    name: 'Japanese/Korean',
    icon: '🍱',
    items: [
      { id: 1, name: 'Sushi Platter', prompt: 'Elegant sushi platter with variety' },
      { id: 2, name: 'Ramen', prompt: 'Steaming ramen bowl with toppings' },
      { id: 3, name: 'Tempura', prompt: 'Crispy tempura with dipping sauce' },
      { id: 4, name: 'Teriyaki', prompt: 'Glazed teriyaki chicken with rice' },
      { id: 5, name: 'Miso Soup', prompt: 'Traditional miso soup with tofu' },
      { id: 6, name: 'Sashimi', prompt: 'Fresh sashimi slices arranged artfully' },
      { id: 7, name: 'Bibimbap', prompt: 'Colorful bibimbap bowl with egg' },
      { id: 8, name: 'Korean BBQ', prompt: 'Grilled Korean BBQ meat on grill' },
      { id: 9, name: 'Kimchi', prompt: 'Spicy fermented kimchi' },
      { id: 10, name: 'Tonkatsu', prompt: 'Crispy breaded tonkatsu cutlet' },
      { id: 11, name: 'Udon', prompt: 'Thick udon noodles in broth' },
      { id: 12, name: 'Gyoza', prompt: 'Pan-fried gyoza dumplings' },
      { id: 13, name: 'Bulgogi', prompt: 'Marinated bulgogi beef with vegetables' },
      { id: 14, name: 'Onigiri', prompt: 'Rice onigiri with nori wrap' },
      { id: 15, name: 'Tteokbokki', prompt: 'Spicy Korean rice cakes' },
      { id: 16, name: 'Yakitori', prompt: 'Grilled yakitori skewers' },
      { id: 17, name: 'Bento Box', prompt: 'Traditional bento box with compartments' },
      { id: 18, name: 'Matcha Dessert', prompt: 'Green matcha dessert with cream' },
      { id: 19, name: 'Mochi', prompt: 'Colorful mochi rice cakes' },
      { id: 20, name: 'Korean Fried Chicken', prompt: 'Crispy Korean fried chicken with sauce' }
    ]
      }
    }
  },
  'Construction': {
    title: 'Construction Categories',
    categories: {
      heavymachinery: {
        name: 'Heavy Machinery',
        icon: '🚜',
        items: [
          { id: 1, name: 'Excavator', prompt: 'Powerful excavator digging on construction site' },
          { id: 2, name: 'Bulldozer', prompt: 'Heavy bulldozer moving earth and materials' },
          { id: 3, name: 'Crane', prompt: 'Tower crane lifting materials at construction site' },
          { id: 4, name: 'Concrete Mixer', prompt: 'Industrial concrete mixer truck at work' },
          { id: 5, name: 'Dump Truck', prompt: 'Large dump truck hauling construction materials' },
          { id: 6, name: 'Forklift', prompt: 'Forklift moving heavy building materials' },
          { id: 7, name: 'Road Roller', prompt: 'Heavy road roller compacting asphalt' },
          { id: 8, name: 'Backhoe Loader', prompt: 'Backhoe loader excavating and loading' },
          { id: 9, name: 'Grader', prompt: 'Motor grader leveling construction ground' },
          { id: 10, name: 'Paver', prompt: 'Asphalt paver laying new road surface' },
          { id: 11, name: 'Compactor', prompt: 'Soil compactor preparing foundation' },
          { id: 12, name: 'Loader', prompt: 'Wheel loader moving construction debris' },
          { id: 13, name: 'Drilling Machine', prompt: 'Heavy drilling rig on construction site' },
          { id: 14, name: 'Pile Driver', prompt: 'Pile driving machine at foundation work' },
          { id: 15, name: 'Concrete Pump', prompt: 'Concrete pump truck delivering concrete' },
          { id: 16, name: 'Trencher', prompt: 'Trenching machine digging utility lines' },
          { id: 17, name: 'Skid Steer', prompt: 'Compact skid steer loader working' },
          { id: 18, name: 'Telehandler', prompt: 'Telescopic handler lifting materials' },
          { id: 19, name: 'Mobile Crane', prompt: 'Mobile crane at construction project' },
          { id: 20, name: 'Scissor Lift', prompt: 'Elevated scissor lift platform for workers' }
        ]
      },
      materials: {
        name: 'Building Materials',
        icon: '🧱',
        items: [
          { id: 1, name: 'Bricks', prompt: 'Stack of red construction bricks' },
          { id: 2, name: 'Concrete Blocks', prompt: 'Concrete blocks arranged for construction' },
          { id: 3, name: 'Steel Beams', prompt: 'Heavy steel I-beams for structure' },
          { id: 4, name: 'Lumber', prompt: 'Wooden lumber planks stacked' },
          { id: 5, name: 'Cement Bags', prompt: 'Cement bags piled at construction site' },
          { id: 6, name: 'Rebar', prompt: 'Steel reinforcement bars bundled' },
          { id: 7, name: 'Roofing Tiles', prompt: 'Clay or concrete roofing tiles' },
          { id: 8, name: 'Insulation', prompt: 'Building insulation materials rolls' },
          { id: 9, name: 'Drywall', prompt: 'Gypsum drywall sheets stacked' },
          { id: 10, name: 'Glass Panels', prompt: 'Large glass panels for windows' },
          { id: 11, name: 'Paint Supplies', prompt: 'Paint buckets and supplies organized' },
          { id: 12, name: 'Pipes & Plumbing', prompt: 'PVC and metal pipes for plumbing' },
          { id: 13, name: 'Electrical Wires', prompt: 'Electrical cables and wiring coils' },
          { id: 14, name: 'Flooring', prompt: 'Hardwood or tile flooring materials' },
          { id: 15, name: 'Sand & Gravel', prompt: 'Construction sand and gravel piles' },
          { id: 16, name: 'Scaffolding', prompt: 'Metal scaffolding structure assembled' },
          { id: 17, name: 'Windows & Doors', prompt: 'New windows and door frames' },
          { id: 18, name: 'HVAC Units', prompt: 'Air conditioning HVAC systems' },
          { id: 19, name: 'Stone & Marble', prompt: 'Natural stone and marble slabs' },
          { id: 20, name: 'Hardware & Fasteners', prompt: 'Construction hardware and fasteners' }
        ]
      },
      sites: {
        name: 'Construction Sites',
        icon: '🏗️',
        items: [
          { id: 1, name: 'High-Rise Building', prompt: 'High-rise building under construction' },
          { id: 2, name: 'Residential Complex', prompt: 'Residential apartment construction site' },
          { id: 3, name: 'Commercial Building', prompt: 'Commercial office building construction' },
          { id: 4, name: 'Bridge Construction', prompt: 'Bridge construction over water or valley' },
          { id: 5, name: 'Road Construction', prompt: 'Highway or road construction project' },
          { id: 6, name: 'Tunnel Work', prompt: 'Tunnel excavation and construction' },
          { id: 7, name: 'Foundation Work', prompt: 'Building foundation excavation and pouring' },
          { id: 8, name: 'Renovation Site', prompt: 'Building renovation and remodeling work' },
          { id: 9, name: 'Demolition', prompt: 'Controlled building demolition site' },
          { id: 10, name: 'Site Preparation', prompt: 'Land clearing and site preparation' },
          { id: 11, name: 'Steel Framework', prompt: 'Steel frame structure being erected' },
          { id: 12, name: 'Roofing Work', prompt: 'Workers installing roof on building' },
          { id: 13, name: 'Interior Work', prompt: 'Interior construction and finishing' },
          { id: 14, name: 'Exterior Facade', prompt: 'Building exterior facade installation' },
          { id: 15, name: 'Parking Structure', prompt: 'Multi-level parking garage construction' },
          { id: 16, name: 'Industrial Facility', prompt: 'Industrial warehouse construction' },
          { id: 17, name: 'Shopping Mall', prompt: 'Large shopping center under construction' },
          { id: 18, name: 'Stadium', prompt: 'Sports stadium construction project' },
          { id: 19, name: 'Airport Terminal', prompt: 'Airport terminal building construction' },
          { id: 20, name: 'Hospital Building', prompt: 'Medical facility construction site' }
        ]
      },
      safety: {
        name: 'Safety & Equipment',
        icon: '⚠️',
        items: [
          { id: 1, name: 'Hard Hat', prompt: 'Yellow safety hard hat with branding' },
          { id: 2, name: 'Safety Vest', prompt: 'High-visibility safety vest' },
          { id: 3, name: 'Safety Boots', prompt: 'Steel-toe safety work boots' },
          { id: 4, name: 'Safety Gloves', prompt: 'Heavy-duty work gloves' },
          { id: 5, name: 'Safety Harness', prompt: 'Fall protection harness equipment' },
          { id: 6, name: 'Safety Goggles', prompt: 'Protective safety goggles' },
          { id: 7, name: 'Ear Protection', prompt: 'Noise-canceling ear muffs' },
          { id: 8, name: 'Dust Mask', prompt: 'Respirator dust mask for workers' },
          { id: 9, name: 'Fire Extinguisher', prompt: 'Industrial fire extinguisher' },
          { id: 10, name: 'First Aid Kit', prompt: 'Construction site first aid kit' },
          { id: 11, name: 'Safety Barriers', prompt: 'Orange construction safety barriers' },
          { id: 12, name: 'Warning Signs', prompt: 'Construction warning and safety signs' },
          { id: 13, name: 'Traffic Cones', prompt: 'Orange traffic safety cones arranged' },
          { id: 14, name: 'Caution Tape', prompt: 'Yellow caution tape securing area' },
          { id: 15, name: 'Safety Net', prompt: 'Fall protection safety netting' },
          { id: 16, name: 'Ladder', prompt: 'Stable construction ladder' },
          { id: 17, name: 'Tool Belt', prompt: 'Worker tool belt with equipment' },
          { id: 18, name: 'Measuring Tools', prompt: 'Tape measure and leveling tools' },
          { id: 19, name: 'Power Tools', prompt: 'Professional power tools arranged' },
          { id: 20, name: 'Safety Signage', prompt: 'Digital safety information display' }
        ]
      },
      projects: {
        name: 'Project Showcase',
        icon: '📋',
        items: [
          { id: 1, name: 'Blueprint Plans', prompt: 'Architectural blueprints and plans' },
          { id: 2, name: 'Project Timeline', prompt: 'Construction project schedule board' },
          { id: 3, name: 'Team Meeting', prompt: 'Construction team planning meeting' },
          { id: 4, name: 'Site Inspection', prompt: 'Inspector reviewing construction site' },
          { id: 5, name: 'Before/After', prompt: 'Before and after construction comparison' },
          { id: 6, name: 'Completed Project', prompt: 'Finished building exterior view' },
          { id: 7, name: 'Progress Photos', prompt: 'Construction progress documentation' },
          { id: 8, name: 'Handover Ceremony', prompt: 'Project completion handover event' },
          { id: 9, name: 'Quality Check', prompt: 'Quality inspector examining work' },
          { id: 10, name: 'Client Walkthrough', prompt: 'Client touring construction site' },
          { id: 11, name: 'Drone View', prompt: 'Aerial drone view of construction site' },
          { id: 12, name: 'Night Construction', prompt: 'Construction site lit up at night' },
          { id: 13, name: 'Weather Challenges', prompt: 'Construction work in challenging weather' },
          { id: 14, name: 'Team Celebration', prompt: 'Construction team celebrating milestone' },
          { id: 15, name: '3D Rendering', prompt: 'Computer 3D rendering of project' },
          { id: 16, name: 'Award Ceremony', prompt: 'Construction project award presentation' },
          { id: 17, name: 'Sustainability', prompt: 'Green building sustainable features' },
          { id: 18, name: 'Technology Use', prompt: 'Modern tech in construction' },
          { id: 19, name: 'Grand Opening', prompt: 'Building grand opening ceremony' },
          { id: 20, name: 'Client Testimonial', prompt: 'Happy client with completed project' }
        ]
      },
      tools: {
        name: 'Tools & Equipment',
        icon: '🔨',
        items: [
          { id: 1, name: 'Power Drill', prompt: 'Professional power drill tool' },
          { id: 2, name: 'Hammer', prompt: 'Construction hammer tool' },
          { id: 3, name: 'Saw', prompt: 'Electric circular saw cutting' },
          { id: 4, name: 'Wrench Set', prompt: 'Complete wrench tool set' },
          { id: 5, name: 'Screwdriver Set', prompt: 'Variety of screwdrivers organized' },
          { id: 6, name: 'Nail Gun', prompt: 'Pneumatic nail gun in action' },
          { id: 7, name: 'Angle Grinder', prompt: 'Angle grinder cutting metal' },
          { id: 8, name: 'Welding Equipment', prompt: 'Professional welding torch setup' },
          { id: 9, name: 'Toolbox', prompt: 'Organized construction toolbox' },
          { id: 10, name: 'Level', prompt: 'Spirit level checking alignment' },
          { id: 11, name: 'Pliers Set', prompt: 'Various pliers tools collection' },
          { id: 12, name: 'Chainsaw', prompt: 'Professional chainsaw for lumber' },
          { id: 13, name: 'Jackhammer', prompt: 'Pneumatic jackhammer breaking concrete' },
          { id: 14, name: 'Blowtorch', prompt: 'Propane blowtorch in use' },
          { id: 15, name: 'Trowel', prompt: 'Mason trowel with mortar' },
          { id: 16, name: 'Paint Sprayer', prompt: 'Professional paint spray gun' },
          { id: 17, name: 'Sander', prompt: 'Electric orbital sander smoothing' },
          { id: 18, name: 'Router', prompt: 'Wood router creating edges' },
          { id: 19, name: 'Compressor', prompt: 'Air compressor for pneumatic tools' },
          { id: 20, name: 'Generator', prompt: 'Portable power generator on site' }
        ]
      }
    }
  },
  'Technology': {
    title: 'Tech Categories',
    categories: {
      software: {
        name: 'Software & Apps',
        icon: '💻',
        items: [
          { id: 1, name: 'Mobile App', prompt: 'Modern mobile application interface' },
          { id: 2, name: 'Web Dashboard', prompt: 'Professional web dashboard analytics' },
          { id: 3, name: 'SaaS Platform', prompt: 'Cloud-based SaaS platform interface' },
          { id: 4, name: 'AI Chatbot', prompt: 'AI-powered chatbot conversation' },
          { id: 5, name: 'E-commerce Site', prompt: 'Online shopping platform design' },
          { id: 6, name: 'CRM System', prompt: 'Customer relationship management interface' },
          { id: 7, name: 'Project Management', prompt: 'Project management tool dashboard' },
          { id: 8, name: 'Video Conferencing', prompt: 'Virtual meeting platform interface' },
          { id: 9, name: 'Social Media App', prompt: 'Social networking application' },
          { id: 10, name: 'Messaging App', prompt: 'Instant messaging platform' },
          { id: 11, name: 'Cloud Storage', prompt: 'Cloud file storage interface' },
          { id: 12, name: 'Analytics Tool', prompt: 'Data analytics dashboard' },
          { id: 13, name: 'Code Editor', prompt: 'Programming IDE interface' },
          { id: 14, name: 'Design Tool', prompt: 'Graphic design software' },
          { id: 15, name: 'Game Platform', prompt: 'Gaming application interface' },
          { id: 16, name: 'Learning Platform', prompt: 'Online education LMS system' },
          { id: 17, name: 'Fitness App', prompt: 'Health and fitness tracking app' },
          { id: 18, name: 'Finance App', prompt: 'Banking and finance application' },
          { id: 19, name: 'Travel App', prompt: 'Travel booking platform' },
          { id: 20, name: 'Music Streaming', prompt: 'Music streaming service interface' }
        ]
      },
      hardware: {
        name: 'Hardware & Devices',
        icon: '🖥️',
        items: [
          { id: 1, name: 'Laptop', prompt: 'Modern laptop computer setup' },
          { id: 2, name: 'Smartphone', prompt: 'Latest smartphone device' },
          { id: 3, name: 'Tablet', prompt: 'Digital tablet with stylus' },
          { id: 4, name: 'Server Rack', prompt: 'Data center server equipment' },
          { id: 5, name: 'Smartwatch', prompt: 'Wearable smartwatch technology' },
          { id: 6, name: 'VR Headset', prompt: 'Virtual reality headset device' },
          { id: 7, name: 'Wireless Earbuds', prompt: 'Bluetooth wireless earphones' },
          { id: 8, name: 'Gaming Console', prompt: 'Video game console system' },
          { id: 9, name: 'Smart Speaker', prompt: 'Voice assistant smart speaker' },
          { id: 10, name: 'Drone', prompt: 'Professional camera drone' },
          { id: 11, name: 'Router', prompt: 'High-speed WiFi router' },
          { id: 12, name: 'External Drive', prompt: 'Portable storage hard drive' },
          { id: 13, name: 'Webcam', prompt: 'HD streaming webcam' },
          { id: 14, name: 'Keyboard', prompt: 'Mechanical gaming keyboard' },
          { id: 15, name: 'Mouse', prompt: 'Wireless ergonomic mouse' },
          { id: 16, name: 'Monitor', prompt: 'Ultra-wide curved monitor' },
          { id: 17, name: 'Graphics Card', prompt: 'High-performance GPU card' },
          { id: 18, name: 'Processor', prompt: 'Computer CPU chip' },
          { id: 19, name: 'Smart Home Hub', prompt: 'Home automation control hub' },
          { id: 20, name: '3D Printer', prompt: 'Desktop 3D printing machine' }
        ]
      },
      cloud: {
        name: 'Cloud & Infrastructure',
        icon: '☁️',
        items: [
          { id: 1, name: 'Cloud Architecture', prompt: 'Cloud infrastructure diagram' },
          { id: 2, name: 'Data Center', prompt: 'Modern data center facility' },
          { id: 3, name: 'API Integration', prompt: 'API connection visualization' },
          { id: 4, name: 'Microservices', prompt: 'Microservices architecture diagram' },
          { id: 5, name: 'Load Balancer', prompt: 'Traffic load balancing system' },
          { id: 6, name: 'Database Cluster', prompt: 'Distributed database setup' },
          { id: 7, name: 'CDN Network', prompt: 'Content delivery network map' },
          { id: 8, name: 'Kubernetes', prompt: 'Container orchestration visualization' },
          { id: 9, name: 'Docker Containers', prompt: 'Containerized application stack' },
          { id: 10, name: 'CI/CD Pipeline', prompt: 'Automated deployment pipeline' },
          { id: 11, name: 'Monitoring Dashboard', prompt: 'System performance monitoring' },
          { id: 12, name: 'Security Gateway', prompt: 'Network security firewall' },
          { id: 13, name: 'Backup System', prompt: 'Automated backup infrastructure' },
          { id: 14, name: 'Serverless', prompt: 'Serverless computing functions' },
          { id: 15, name: 'Edge Computing', prompt: 'Edge computing nodes network' },
          { id: 16, name: 'Blockchain Network', prompt: 'Distributed blockchain nodes' },
          { id: 17, name: 'VPN Connection', prompt: 'Secure VPN tunnel setup' },
          { id: 18, name: 'Cache Layer', prompt: 'Caching system architecture' },
          { id: 19, name: 'Message Queue', prompt: 'Event-driven messaging system' },
          { id: 20, name: 'Scaling System', prompt: 'Auto-scaling infrastructure' }
        ]
      },
      ai: {
        name: 'AI & Machine Learning',
        icon: '🤖',
        items: [
          { id: 1, name: 'Neural Network', prompt: 'Deep learning neural network visualization' },
          { id: 2, name: 'AI Training', prompt: 'Machine learning model training process' },
          { id: 3, name: 'Computer Vision', prompt: 'Image recognition AI system' },
          { id: 4, name: 'NLP Processing', prompt: 'Natural language processing engine' },
          { id: 5, name: 'Predictive Analytics', prompt: 'AI predictive modeling dashboard' },
          { id: 6, name: 'Recommendation Engine', prompt: 'AI recommendation system' },
          { id: 7, name: 'Autonomous Vehicle', prompt: 'Self-driving car AI technology' },
          { id: 8, name: 'Facial Recognition', prompt: 'AI facial recognition system' },
          { id: 9, name: 'Voice Assistant', prompt: 'AI voice recognition interface' },
          { id: 10, name: 'Sentiment Analysis', prompt: 'Text sentiment AI analysis' },
          { id: 11, name: 'Data Labeling', prompt: 'AI training data annotation' },
          { id: 12, name: 'Model Deployment', prompt: 'ML model deployment pipeline' },
          { id: 13, name: 'AI Ethics', prompt: 'Responsible AI framework' },
          { id: 14, name: 'Robotics AI', prompt: 'AI-powered robotic system' },
          { id: 15, name: 'Generative AI', prompt: 'AI content generation tool' },
          { id: 16, name: 'Anomaly Detection', prompt: 'AI anomaly detection system' },
          { id: 17, name: 'Transfer Learning', prompt: 'AI model transfer learning' },
          { id: 18, name: 'Reinforcement Learning', prompt: 'RL agent training environment' },
          { id: 19, name: 'Edge AI', prompt: 'AI processing on edge devices' },
          { id: 20, name: 'AI Optimization', prompt: 'Model optimization techniques' }
        ]
      },
      cybersecurity: {
        name: 'Cybersecurity',
        icon: '🔐',
        items: [
          { id: 1, name: 'Security Dashboard', prompt: 'Cybersecurity monitoring center' },
          { id: 2, name: 'Encryption', prompt: 'Data encryption technology' },
          { id: 3, name: 'Firewall', prompt: 'Network firewall protection' },
          { id: 4, name: 'Threat Detection', prompt: 'Real-time threat detection system' },
          { id: 5, name: 'Penetration Testing', prompt: 'Security vulnerability assessment' },
          { id: 6, name: 'Access Control', prompt: 'Multi-factor authentication system' },
          { id: 7, name: 'Security Audit', prompt: 'Security compliance audit' },
          { id: 8, name: 'Incident Response', prompt: 'Security incident response team' },
          { id: 9, name: 'DDoS Protection', prompt: 'Anti-DDoS defense system' },
          { id: 10, name: 'Antivirus', prompt: 'Malware protection software' },
          { id: 11, name: 'VPN Security', prompt: 'Secure VPN encryption' },
          { id: 12, name: 'Zero Trust', prompt: 'Zero trust security architecture' },
          { id: 13, name: 'SIEM System', prompt: 'Security information management' },
          { id: 14, name: 'Endpoint Protection', prompt: 'Device security solution' },
          { id: 15, name: 'Security Training', prompt: 'Cybersecurity awareness training' },
          { id: 16, name: 'Phishing Defense', prompt: 'Anti-phishing protection' },
          { id: 17, name: 'Vulnerability Scan', prompt: 'Security vulnerability scanner' },
          { id: 18, name: 'Data Privacy', prompt: 'Privacy compliance system' },
          { id: 19, name: 'Secure Coding', prompt: 'Secure software development' },
          { id: 20, name: 'Blockchain Security', prompt: 'Cryptocurrency security' }
        ]
      },
      team: {
        name: 'Tech Team & Culture',
        icon: '👨‍💻',
        items: [
          { id: 1, name: 'Dev Team', prompt: 'Software development team working' },
          { id: 2, name: 'Code Review', prompt: 'Developers reviewing code together' },
          { id: 3, name: 'Hackathon', prompt: 'Team participating in hackathon' },
          { id: 4, name: 'Standup Meeting', prompt: 'Daily standup scrum meeting' },
          { id: 5, name: 'Remote Work', prompt: 'Distributed team remote collaboration' },
          { id: 6, name: 'Pair Programming', prompt: 'Two developers pair programming' },
          { id: 7, name: 'Tech Conference', prompt: 'Technology conference presentation' },
          { id: 8, name: 'Office Setup', prompt: 'Modern tech office workspace' },
          { id: 9, name: 'Whiteboard Session', prompt: 'Team brainstorming on whiteboard' },
          { id: 10, name: 'Product Launch', prompt: 'New product launch celebration' },
          { id: 11, name: 'Client Demo', prompt: 'Software demo presentation to client' },
          { id: 12, name: 'Tech Interview', prompt: 'Technical interview session' },
          { id: 13, name: 'Training Workshop', prompt: 'Technical skills workshop' },
          { id: 14, name: 'Code Documentation', prompt: 'Developer writing documentation' },
          { id: 15, name: 'Bug Fixing', prompt: 'Team debugging code issues' },
          { id: 16, name: 'Sprint Planning', prompt: 'Agile sprint planning meeting' },
          { id: 17, name: 'Tech Awards', prompt: 'Technology innovation awards' },
          { id: 18, name: 'Mentorship', prompt: 'Senior dev mentoring junior' },
          { id: 19, name: 'Late Night Coding', prompt: 'Developers working late on project' },
          { id: 20, name: 'Tech Community', prompt: 'Developer community meetup' }
        ]
      }
    }
  },
  'Healthcare': {
    title: 'Healthcare Categories',
    categories: {
      medical: {
        name: 'Medical Services',
        icon: '🏥',
        items: [
          { id: 1, name: 'Doctor Consultation', prompt: 'Doctor consulting with patient' },
          { id: 2, name: 'Surgery Room', prompt: 'Modern surgical operation theater' },
          { id: 3, name: 'Emergency Care', prompt: 'Emergency room medical care' },
          { id: 4, name: 'Patient Care', prompt: 'Nurse caring for patient' },
          { id: 5, name: 'Medical Examination', prompt: 'Physical examination checkup' },
          { id: 6, name: 'Laboratory Testing', prompt: 'Medical lab testing facility' },
          { id: 7, name: 'Radiology', prompt: 'X-ray and imaging department' },
          { id: 8, name: 'Pharmacy', prompt: 'Hospital pharmacy dispensary' },
          { id: 9, name: 'Physical Therapy', prompt: 'Physiotherapy rehabilitation session' },
          { id: 10, name: 'Mental Health', prompt: 'Counseling therapy session' },
          { id: 11, name: 'Pediatric Care', prompt: 'Children healthcare services' },
          { id: 12, name: 'Maternity Ward', prompt: 'Maternity and childbirth care' },
          { id: 13, name: 'ICU', prompt: 'Intensive care unit facility' },
          { id: 14, name: 'Cardiology', prompt: 'Heart care cardiology center' },
          { id: 15, name: 'Dental Care', prompt: 'Dental clinic treatment' },
          { id: 16, name: 'Eye Care', prompt: 'Ophthalmology eye examination' },
          { id: 17, name: 'Vaccination', prompt: 'Immunization vaccine administration' },
          { id: 18, name: 'Home Healthcare', prompt: 'At-home medical care service' },
          { id: 19, name: 'Telemedicine', prompt: 'Virtual online medical consultation' },
          { id: 20, name: 'Medical Research', prompt: 'Clinical research laboratory' }
        ]
      },
      equipment: {
        name: 'Medical Equipment',
        icon: '🩺',
        items: [
          { id: 1, name: 'Stethoscope', prompt: 'Professional medical stethoscope' },
          { id: 2, name: 'MRI Machine', prompt: 'Advanced MRI scanning equipment' },
          { id: 3, name: 'CT Scanner', prompt: 'CT scan imaging machine' },
          { id: 4, name: 'Ultrasound', prompt: 'Ultrasound scanning device' },
          { id: 5, name: 'ECG Monitor', prompt: 'Heart monitoring ECG machine' },
          { id: 6, name: 'Ventilator', prompt: 'Medical breathing ventilator' },
          { id: 7, name: 'Defibrillator', prompt: 'Emergency defibrillator device' },
          { id: 8, name: 'Surgical Tools', prompt: 'Sterile surgical instruments' },
          { id: 9, name: 'IV Stand', prompt: 'Intravenous drip equipment' },
          { id: 10, name: 'Hospital Bed', prompt: 'Adjustable medical hospital bed' },
          { id: 11, name: 'Wheelchair', prompt: 'Medical wheelchair equipment' },
          { id: 12, name: 'Oxygen Tank', prompt: 'Medical oxygen supply system' },
          { id: 13, name: 'Blood Pressure Monitor', prompt: 'BP measurement device' },
          { id: 14, name: 'Thermometer', prompt: 'Digital medical thermometer' },
          { id: 15, name: 'Microscope', prompt: 'Laboratory research microscope' },
          { id: 16, name: 'X-Ray Machine', prompt: 'Radiography X-ray equipment' },
          { id: 17, name: 'Incubator', prompt: 'Neonatal care incubator' },
          { id: 18, name: 'Autoclave', prompt: 'Medical sterilization equipment' },
          { id: 19, name: 'PPE Kit', prompt: 'Personal protective equipment set' },
          { id: 20, name: 'Medical Cart', prompt: 'Mobile medical supply cart' }
        ]
      }
    }
  },
  'Real Estate': {
    title: 'Property Categories',
    categories: {
      residential: {
        name: 'Residential Properties',
        icon: '🏠',
        items: [
          { id: 1, name: 'Luxury Villa', prompt: 'Luxury villa with modern architecture' },
          { id: 2, name: 'Apartment', prompt: 'Modern apartment interior' },
          { id: 3, name: 'Townhouse', prompt: 'Contemporary townhouse exterior' },
          { id: 4, name: 'Penthouse', prompt: 'Luxury penthouse with city view' },
          { id: 5, name: 'Studio', prompt: 'Compact studio apartment design' },
          { id: 6, name: 'Family Home', prompt: 'Spacious family house' },
          { id: 7, name: 'Cottage', prompt: 'Cozy countryside cottage' },
          { id: 8, name: 'Mansion', prompt: 'Grand mansion estate' },
          { id: 9, name: 'Beach House', prompt: 'Oceanfront beach property' },
          { id: 10, name: 'Mountain Cabin', prompt: 'Mountain retreat cabin' },
          { id: 11, name: 'Living Room', prompt: 'Elegant living room interior' },
          { id: 12, name: 'Kitchen', prompt: 'Modern modular kitchen' },
          { id: 13, name: 'Bedroom', prompt: 'Luxurious master bedroom' },
          { id: 14, name: 'Bathroom', prompt: 'Spa-like bathroom design' },
          { id: 15, name: 'Home Office', prompt: 'Productive home workspace' },
          { id: 16, name: 'Garden', prompt: 'Landscaped outdoor garden' },
          { id: 17, name: 'Swimming Pool', prompt: 'Backyard swimming pool' },
          { id: 18, name: 'Balcony', prompt: 'Spacious apartment balcony' },
          { id: 19, name: 'Garage', prompt: 'Modern car garage space' },
          { id: 20, name: 'Entrance', prompt: 'Grand entrance foyer' }
        ]
      },
      commercial: {
        name: 'Commercial Properties',
        icon: '🏢',
        items: [
          { id: 1, name: 'Office Building', prompt: 'Corporate office building exterior' },
          { id: 2, name: 'Retail Space', prompt: 'Modern retail shop interior' },
          { id: 3, name: 'Shopping Mall', prompt: 'Large shopping center' },
          { id: 4, name: 'Restaurant Space', prompt: 'Commercial restaurant interior' },
          { id: 5, name: 'Hotel', prompt: 'Luxury hotel property' },
          { id: 6, name: 'Warehouse', prompt: 'Industrial warehouse facility' },
          { id: 7, name: 'Co-working Space', prompt: 'Modern co-working office' },
          { id: 8, name: 'Showroom', prompt: 'Product display showroom' },
          { id: 9, name: 'Gym Facility', prompt: 'Commercial fitness center' },
          { id: 10, name: 'Clinic Space', prompt: 'Medical clinic interior' },
          { id: 11, name: 'Conference Room', prompt: 'Business meeting conference room' },
          { id: 12, name: 'Reception Area', prompt: 'Professional reception lobby' },
          { id: 13, name: 'Cafeteria', prompt: 'Office cafeteria space' },
          { id: 14, name: 'Parking Lot', prompt: 'Commercial parking facility' },
          { id: 15, name: 'Data Center', prompt: 'Technology data center' },
          { id: 16, name: 'Factory Unit', prompt: 'Manufacturing factory space' },
          { id: 17, name: 'Storage Unit', prompt: 'Self-storage facility' },
          { id: 18, name: 'Event Venue', prompt: 'Event hall venue space' },
          { id: 19, name: 'Theater', prompt: 'Cinema or theater hall' },
          { id: 20, name: 'Lab Space', prompt: 'Research laboratory facility' }
        ]
      }
    }
  },
  'Retail': {
    title: 'Retail Categories',
    categories: {
      products: {
        name: 'Products & Merchandise',
        icon: '🛍️',
        items: [
          { id: 1, name: 'Fashion Items', prompt: 'Stylish clothing and fashion accessories display' },
          { id: 2, name: 'Electronics', prompt: 'Modern electronics and gadgets showcase' },
          { id: 3, name: 'Home Decor', prompt: 'Beautiful home decoration items arrangement' },
          { id: 4, name: 'Jewelry', prompt: 'Elegant jewelry pieces with luxury presentation' },
          { id: 5, name: 'Shoes', prompt: 'Trendy footwear collection display' },
          { id: 6, name: 'Bags & Accessories', prompt: 'Stylish bags and accessories showcase' },
          { id: 7, name: 'Beauty Products', prompt: 'Cosmetics and beauty products arrangement' },
          { id: 8, name: 'Sports Equipment', prompt: 'Athletic gear and sports equipment' },
          { id: 9, name: 'Books & Stationery', prompt: 'Books and office supplies display' },
          { id: 10, name: 'Toys & Games', prompt: 'Colorful toys and games collection' },
          { id: 11, name: 'Furniture', prompt: 'Modern furniture pieces showcase' },
          { id: 12, name: 'Appliances', prompt: 'Home appliances and kitchen equipment' },
          { id: 13, name: 'Art & Crafts', prompt: 'Creative art supplies and craft materials' },
          { id: 14, name: 'Garden & Outdoor', prompt: 'Outdoor and gardening products' },
          { id: 15, name: 'Pet Supplies', prompt: 'Pet care products and accessories' },
          { id: 16, name: 'Health & Wellness', prompt: 'Health and wellness products display' },
          { id: 17, name: 'Automotive Parts', prompt: 'Car parts and automotive accessories' },
          { id: 18, name: 'Tools & Hardware', prompt: 'Tools and hardware equipment' },
          { id: 19, name: 'Seasonal Items', prompt: 'Holiday and seasonal merchandise' },
          { id: 20, name: 'Gift Items', prompt: 'Special gift products and packaging' }
        ]
      },
      store: {
        name: 'Store & Shopping',
        icon: '🏪',
        items: [
          { id: 1, name: 'Store Front', prompt: 'Attractive retail store exterior and entrance' },
          { id: 2, name: 'Interior Layout', prompt: 'Well-organized store interior with products' },
          { id: 3, name: 'Checkout Counter', prompt: 'Modern point-of-sale checkout area' },
          { id: 4, name: 'Product Displays', prompt: 'Creative product display arrangements' },
          { id: 5, name: 'Window Display', prompt: 'Eye-catching store window showcase' },
          { id: 6, name: 'Shopping Experience', prompt: 'Customers enjoying shopping experience' },
          { id: 7, name: 'Staff Service', prompt: 'Friendly staff helping customers' },
          { id: 8, name: 'Sale Events', prompt: 'Promotional sale event setup' },
          { id: 9, name: 'Fitting Rooms', prompt: 'Clean and modern fitting room area' },
          { id: 10, name: 'Storage Area', prompt: 'Organized retail storage and inventory' },
          { id: 11, name: 'Customer Queue', prompt: 'Organized customer service line' },
          { id: 12, name: 'Shopping Bags', prompt: 'Branded shopping bags and packaging' },
          { id: 13, name: 'Price Tags', prompt: 'Clear pricing and product information' },
          { id: 14, name: 'Security System', prompt: 'Modern retail security setup' },
          { id: 15, name: 'Loyalty Program', prompt: 'Customer loyalty program materials' },
          { id: 16, name: 'Online Integration', prompt: 'Digital and online shopping integration' },
          { id: 17, name: 'Delivery Service', prompt: 'Retail delivery and pickup service' },
          { id: 18, name: 'Customer Reviews', prompt: 'Customer feedback and review display' },
          { id: 19, name: 'Seasonal Decor', prompt: 'Store decorated for seasons and holidays' },
          { id: 20, name: 'Grand Opening', prompt: 'Store grand opening celebration' }
        ]
      }
    }
  },
  'Finance': {
    title: 'Finance Categories',
    categories: {
      banking: {
        name: 'Banking Services',
        icon: '🏦',
        items: [
          { id: 1, name: 'Bank Branch', prompt: 'Modern bank branch interior with professional atmosphere' },
          { id: 2, name: 'ATM Services', prompt: 'ATM machine and banking technology' },
          { id: 3, name: 'Customer Service', prompt: 'Bank teller helping customer with transaction' },
          { id: 4, name: 'Loan Consultation', prompt: 'Professional loan advisor meeting with client' },
          { id: 5, name: 'Investment Planning', prompt: 'Financial advisor discussing investment portfolio' },
          { id: 6, name: 'Mobile Banking', prompt: 'Digital mobile banking app interface' },
          { id: 7, name: 'Credit Cards', prompt: 'Premium credit cards and payment solutions' },
          { id: 8, name: 'Safe Deposit', prompt: 'Secure safe deposit box facility' },
          { id: 9, name: 'Business Banking', prompt: 'Corporate banking services for businesses' },
          { id: 10, name: 'Mortgage Services', prompt: 'Home mortgage consultation and approval' },
          { id: 11, name: 'Wealth Management', prompt: 'Private wealth management consultation' },
          { id: 12, name: 'Financial Planning', prompt: 'Retirement and financial planning session' },
          { id: 13, name: 'Currency Exchange', prompt: 'Foreign currency exchange services' },
          { id: 14, name: 'Online Banking', prompt: 'Secure online banking platform' },
          { id: 15, name: 'Insurance Services', prompt: 'Financial insurance and protection plans' },
          { id: 16, name: 'Student Loans', prompt: 'Education financing and student loans' },
          { id: 17, name: 'Small Business', prompt: 'Small business banking solutions' },
          { id: 18, name: 'Retirement Plans', prompt: '401k and retirement planning services' },
          { id: 19, name: 'Financial Security', prompt: 'Cybersecurity and fraud protection' },
          { id: 20, name: 'Economic Analysis', prompt: 'Market analysis and economic reports' }
        ]
      },
      investment: {
        name: 'Investment & Trading',
        icon: '📈',
        items: [
          { id: 1, name: 'Stock Market', prompt: 'Stock market trading floor and displays' },
          { id: 2, name: 'Portfolio Management', prompt: 'Investment portfolio analysis and charts' },
          { id: 3, name: 'Trading Platform', prompt: 'Professional trading software interface' },
          { id: 4, name: 'Financial Charts', prompt: 'Market charts and financial data visualization' },
          { id: 5, name: 'Cryptocurrency', prompt: 'Digital cryptocurrency trading and blockchain' },
          { id: 6, name: 'Mutual Funds', prompt: 'Diversified mutual fund investment options' },
          { id: 7, name: 'Real Estate Investment', prompt: 'Property investment and REIT portfolios' },
          { id: 8, name: 'Bonds & Securities', prompt: 'Government and corporate bonds trading' },
          { id: 9, name: 'Commodities', prompt: 'Gold, oil, and commodity trading markets' },
          { id: 10, name: 'Forex Trading', prompt: 'Foreign exchange currency trading' },
          { id: 11, name: 'Risk Assessment', prompt: 'Investment risk analysis and management' },
          { id: 12, name: 'Market Research', prompt: 'Financial market research and analysis' },
          { id: 13, name: 'Dividend Income', prompt: 'Dividend-paying stocks and income streams' },
          { id: 14, name: 'Options Trading', prompt: 'Options and derivatives trading strategies' },
          { id: 15, name: 'ESG Investing', prompt: 'Sustainable and ethical investment options' },
          { id: 16, name: 'Robo Advisors', prompt: 'Automated investment management platforms' },
          { id: 17, name: 'Tax Planning', prompt: 'Tax-efficient investment strategies' },
          { id: 18, name: 'Alternative Investments', prompt: 'Private equity and alternative assets' },
          { id: 19, name: 'Financial Education', prompt: 'Investment education and learning resources' },
          { id: 20, name: 'Market Volatility', prompt: 'Managing investments during market changes' }
        ]
      }
    }
  },
  'Education': {
    title: 'Education Categories',
    categories: {
      classroom: {
        name: 'Classroom & Learning',
        icon: '📚',
        items: [
          { id: 1, name: 'Modern Classroom', prompt: 'Contemporary classroom with students and teacher' },
          { id: 2, name: 'Online Learning', prompt: 'Digital learning platform and virtual classroom' },
          { id: 3, name: 'Laboratory', prompt: 'Science laboratory with equipment and experiments' },
          { id: 4, name: 'Library', prompt: 'Modern library with books and study areas' },
          { id: 5, name: 'Graduation', prompt: 'Graduation ceremony with caps and diplomas' },
          { id: 6, name: 'Study Group', prompt: 'Students collaborating in study session' },
          { id: 7, name: 'Teacher Training', prompt: 'Professional development for educators' },
          { id: 8, name: 'School Campus', prompt: 'Beautiful school or university campus' },
          { id: 9, name: 'Educational Technology', prompt: 'Interactive whiteboards and learning tech' },
          { id: 10, name: 'Student Activities', prompt: 'Extracurricular activities and clubs' },
          { id: 11, name: 'Art Class', prompt: 'Creative art and design classroom' },
          { id: 12, name: 'Music Education', prompt: 'Music class with instruments and performance' },
          { id: 13, name: 'Sports Education', prompt: 'Physical education and sports training' },
          { id: 14, name: 'Special Needs', prompt: 'Inclusive education for special needs students' },
          { id: 15, name: 'Early Childhood', prompt: 'Preschool and early childhood education' },
          { id: 16, name: 'Adult Education', prompt: 'Adult learning and continuing education' },
          { id: 17, name: 'Vocational Training', prompt: 'Technical and vocational skill training' },
          { id: 18, name: 'Language Learning', prompt: 'Foreign language education and practice' },
          { id: 19, name: 'STEM Education', prompt: 'Science, technology, engineering, and math' },
          { id: 20, name: 'Educational Assessment', prompt: 'Testing and student evaluation methods' }
        ]
      },
      resources: {
        name: 'Educational Resources',
        icon: '📖',
        items: [
          { id: 1, name: 'Textbooks', prompt: 'Educational textbooks and learning materials' },
          { id: 2, name: 'Digital Content', prompt: 'Interactive digital learning content' },
          { id: 3, name: 'Educational Apps', prompt: 'Learning apps and educational software' },
          { id: 4, name: 'Research Papers', prompt: 'Academic research and scholarly articles' },
          { id: 5, name: 'Educational Videos', prompt: 'Instructional videos and tutorials' },
          { id: 6, name: 'Learning Games', prompt: 'Educational games and interactive activities' },
          { id: 7, name: 'Worksheets', prompt: 'Practice worksheets and exercises' },
          { id: 8, name: 'Educational Posters', prompt: 'Classroom posters and visual aids' },
          { id: 9, name: 'Science Models', prompt: 'Educational models and demonstrations' },
          { id: 10, name: 'Maps & Charts', prompt: 'Geographic maps and educational charts' },
          { id: 11, name: 'Art Supplies', prompt: 'Creative art materials for education' },
          { id: 12, name: 'Lab Equipment', prompt: 'Scientific instruments and lab tools' },
          { id: 13, name: 'Musical Instruments', prompt: 'Educational musical instruments' },
          { id: 14, name: 'Sports Equipment', prompt: 'Physical education sports gear' },
          { id: 15, name: 'Technology Tools', prompt: 'Educational technology and devices' },
          { id: 16, name: 'Assessment Tools', prompt: 'Testing and evaluation materials' },
          { id: 17, name: 'Reference Books', prompt: 'Dictionaries, encyclopedias, and references' },
          { id: 18, name: 'Educational Toys', prompt: 'Learning toys for young children' },
          { id: 19, name: 'Presentation Tools', prompt: 'Projectors and presentation equipment' },
          { id: 20, name: 'Study Guides', prompt: 'Exam preparation and study materials' }
        ]
      }
    }
  },
  'Fashion & Beauty': {
    title: 'Fashion & Beauty Categories',
    categories: {
      fashion: {
        name: 'Fashion & Apparel',
        icon: '👗',
        items: [
          { id: 1, name: 'Designer Clothing', prompt: 'High-end designer fashion and couture' },
          { id: 2, name: 'Casual Wear', prompt: 'Comfortable everyday casual clothing' },
          { id: 3, name: 'Formal Attire', prompt: 'Elegant formal wear and business attire' },
          { id: 4, name: 'Seasonal Fashion', prompt: 'Trendy seasonal clothing collections' },
          { id: 5, name: 'Accessories', prompt: 'Fashion accessories and jewelry' },
          { id: 6, name: 'Footwear', prompt: 'Stylish shoes and footwear collection' },
          { id: 7, name: 'Handbags', prompt: 'Designer handbags and purses' },
          { id: 8, name: 'Sunglasses', prompt: 'Trendy sunglasses and eyewear' },
          { id: 9, name: 'Watches', prompt: 'Luxury and fashion watches' },
          { id: 10, name: 'Jewelry', prompt: 'Fine jewelry and fashion accessories' },
          { id: 11, name: 'Swimwear', prompt: 'Stylish swimwear and beachwear' },
          { id: 12, name: 'Activewear', prompt: 'Athletic and fitness fashion' },
          { id: 13, name: 'Lingerie', prompt: 'Intimate apparel and undergarments' },
          { id: 14, name: 'Maternity Wear', prompt: 'Fashionable maternity clothing' },
          { id: 15, name: 'Plus Size Fashion', prompt: 'Inclusive plus size clothing' },
          { id: 16, name: 'Vintage Style', prompt: 'Retro and vintage fashion pieces' },
          { id: 17, name: 'Sustainable Fashion', prompt: 'Eco-friendly and sustainable clothing' },
          { id: 18, name: 'Street Style', prompt: 'Urban street fashion and trends' },
          { id: 19, name: 'Fashion Show', prompt: 'Runway fashion show and models' },
          { id: 20, name: 'Personal Styling', prompt: 'Fashion styling and wardrobe consultation' }
        ]
      },
      beauty: {
        name: 'Beauty & Cosmetics',
        icon: '💄',
        items: [
          { id: 1, name: 'Makeup Products', prompt: 'Professional makeup and cosmetics collection' },
          { id: 2, name: 'Skincare Routine', prompt: 'Complete skincare products and routine' },
          { id: 3, name: 'Hair Styling', prompt: 'Hair styling tools and products' },
          { id: 4, name: 'Nail Art', prompt: 'Creative nail art and manicure designs' },
          { id: 5, name: 'Fragrance', prompt: 'Luxury perfumes and fragrances' },
          { id: 6, name: 'Beauty Tools', prompt: 'Professional beauty tools and brushes' },
          { id: 7, name: 'Spa Treatment', prompt: 'Relaxing spa and wellness treatments' },
          { id: 8, name: 'Facial Care', prompt: 'Facial treatments and skincare therapy' },
          { id: 9, name: 'Hair Salon', prompt: 'Professional hair salon services' },
          { id: 10, name: 'Makeup Tutorial', prompt: 'Step-by-step makeup application' },
          { id: 11, name: 'Beauty Consultation', prompt: 'Personal beauty advice and consultation' },
          { id: 12, name: 'Anti-Aging', prompt: 'Anti-aging skincare and treatments' },
          { id: 13, name: 'Natural Beauty', prompt: 'Organic and natural beauty products' },
          { id: 14, name: 'Men\'s Grooming', prompt: 'Male grooming and skincare products' },
          { id: 15, name: 'Bridal Beauty', prompt: 'Wedding makeup and beauty services' },
          { id: 16, name: 'Color Matching', prompt: 'Foundation and color matching services' },
          { id: 17, name: 'Beauty Trends', prompt: 'Latest beauty trends and innovations' },
          { id: 18, name: 'Eyebrow Styling', prompt: 'Professional eyebrow shaping and styling' },
          { id: 19, name: 'Lash Extensions', prompt: 'Eyelash extensions and enhancement' },
          { id: 20, name: 'Beauty Photography', prompt: 'Professional beauty and glamour photography' }
        ]
      }
    }
  },
  'Facilities Management': {
    title: 'Facilities Categories',
    categories: {
      maintenance: {
        name: 'Maintenance & Repair',
        icon: '🔧',
        items: [
          { id: 1, name: 'HVAC Systems', prompt: 'Heating, ventilation, and air conditioning maintenance' },
          { id: 2, name: 'Electrical Work', prompt: 'Electrical systems maintenance and repair' },
          { id: 3, name: 'Plumbing Services', prompt: 'Plumbing maintenance and pipe repair' },
          { id: 4, name: 'Building Maintenance', prompt: 'General building upkeep and maintenance' },
          { id: 5, name: 'Cleaning Services', prompt: 'Professional cleaning and janitorial services' },
          { id: 6, name: 'Security Systems', prompt: 'Security equipment and surveillance maintenance' },
          { id: 7, name: 'Landscaping', prompt: 'Grounds keeping and landscape maintenance' },
          { id: 8, name: 'Elevator Service', prompt: 'Elevator maintenance and inspection' },
          { id: 9, name: 'Fire Safety', prompt: 'Fire safety systems and equipment check' },
          { id: 10, name: 'Pest Control', prompt: 'Professional pest management services' },
          { id: 11, name: 'Waste Management', prompt: 'Waste disposal and recycling services' },
          { id: 12, name: 'Energy Management', prompt: 'Energy efficiency and utility management' },
          { id: 13, name: 'Preventive Maintenance', prompt: 'Scheduled preventive maintenance programs' },
          { id: 14, name: 'Emergency Repairs', prompt: 'Emergency maintenance and repair services' },
          { id: 15, name: 'Equipment Servicing', prompt: 'Industrial equipment maintenance' },
          { id: 16, name: 'Painting Services', prompt: 'Interior and exterior painting maintenance' },
          { id: 17, name: 'Flooring Maintenance', prompt: 'Floor care and surface maintenance' },
          { id: 18, name: 'Window Cleaning', prompt: 'Professional window and glass cleaning' },
          { id: 19, name: 'Roof Maintenance', prompt: 'Roofing inspection and repair services' },
          { id: 20, name: 'Compliance Inspection', prompt: 'Safety and regulatory compliance checks' }
        ]
      },
      operations: {
        name: 'Operations & Management',
        icon: '🏢',
        items: [
          { id: 1, name: 'Facility Planning', prompt: 'Strategic facility planning and design' },
          { id: 2, name: 'Space Management', prompt: 'Efficient space utilization and planning' },
          { id: 3, name: 'Asset Management', prompt: 'Facility asset tracking and management' },
          { id: 4, name: 'Vendor Management', prompt: 'Service provider coordination and management' },
          { id: 5, name: 'Budget Planning', prompt: 'Facility budget and cost management' },
          { id: 6, name: 'Work Order System', prompt: 'Maintenance request and work order management' },
          { id: 7, name: 'Quality Control', prompt: 'Service quality monitoring and control' },
          { id: 8, name: 'Staff Coordination', prompt: 'Facility team management and coordination' },
          { id: 9, name: 'Technology Integration', prompt: 'Smart building and IoT integration' },
          { id: 10, name: 'Sustainability Programs', prompt: 'Green building and sustainability initiatives' },
          { id: 11, name: 'Risk Management', prompt: 'Facility risk assessment and mitigation' },
          { id: 12, name: 'Performance Metrics', prompt: 'KPI tracking and performance measurement' },
          { id: 13, name: 'Tenant Services', prompt: 'Occupant services and satisfaction' },
          { id: 14, name: 'Move Management', prompt: 'Office relocation and move coordination' },
          { id: 15, name: 'Event Support', prompt: 'Facility support for events and meetings' },
          { id: 16, name: 'Documentation', prompt: 'Facility records and documentation management' },
          { id: 17, name: 'Training Programs', prompt: 'Staff training and development programs' },
          { id: 18, name: 'Emergency Planning', prompt: 'Emergency response and business continuity' },
          { id: 19, name: 'Renovation Projects', prompt: 'Facility renovation and improvement projects' },
          { id: 20, name: 'Benchmarking', prompt: 'Industry benchmarking and best practices' }
        ]
      }
    }
  },
  'Travel & Hospitality': {
    title: 'Travel & Hospitality Categories',
    categories: {
      travel: {
        name: 'Travel & Tourism',
        icon: '✈️',
        items: [
          { id: 1, name: 'Airport Terminal', prompt: 'Modern airport terminal with travelers' },
          { id: 2, name: 'Flight Experience', prompt: 'Airplane cabin and flight services' },
          { id: 3, name: 'Hotel Lobby', prompt: 'Luxury hotel lobby and reception area' },
          { id: 4, name: 'Resort Paradise', prompt: 'Tropical resort with beach and amenities' },
          { id: 5, name: 'City Tourism', prompt: 'Urban sightseeing and city attractions' },
          { id: 6, name: 'Adventure Travel', prompt: 'Outdoor adventure and extreme sports' },
          { id: 7, name: 'Cultural Sites', prompt: 'Historical landmarks and cultural attractions' },
          { id: 8, name: 'Cruise Ship', prompt: 'Luxury cruise ship and ocean travel' },
          { id: 9, name: 'Road Trip', prompt: 'Scenic road trip and highway travel' },
          { id: 10, name: 'Train Journey', prompt: 'Comfortable train travel experience' },
          { id: 11, name: 'Backpacking', prompt: 'Budget backpacking and hostel travel' },
          { id: 12, name: 'Business Travel', prompt: 'Corporate travel and business trips' },
          { id: 13, name: 'Family Vacation', prompt: 'Family-friendly vacation activities' },
          { id: 14, name: 'Honeymoon', prompt: 'Romantic honeymoon destinations' },
          { id: 15, name: 'Group Tours', prompt: 'Organized group travel and tours' },
          { id: 16, name: 'Solo Travel', prompt: 'Independent solo traveler experience' },
          { id: 17, name: 'Eco Tourism', prompt: 'Sustainable and eco-friendly travel' },
          { id: 18, name: 'Luxury Travel', prompt: 'Premium luxury travel experiences' },
          { id: 19, name: 'Travel Planning', prompt: 'Trip planning and itinerary creation' },
          { id: 20, name: 'Travel Photography', prompt: 'Capturing travel memories and destinations' }
        ]
      },
      hospitality: {
        name: 'Hospitality Services',
        icon: '🏨',
        items: [
          { id: 1, name: 'Hotel Room', prompt: 'Comfortable hotel room with amenities' },
          { id: 2, name: 'Restaurant Service', prompt: 'Fine dining restaurant experience' },
          { id: 3, name: 'Concierge Service', prompt: 'Professional concierge assistance' },
          { id: 4, name: 'Spa Services', prompt: 'Relaxing spa and wellness treatments' },
          { id: 5, name: 'Conference Facilities', prompt: 'Business meeting and conference rooms' },
          { id: 6, name: 'Event Venues', prompt: 'Wedding and event hosting facilities' },
          { id: 7, name: 'Room Service', prompt: 'In-room dining and service delivery' },
          { id: 8, name: 'Housekeeping', prompt: 'Professional housekeeping services' },
          { id: 9, name: 'Front Desk', prompt: 'Hotel reception and check-in services' },
          { id: 10, name: 'Valet Service', prompt: 'Parking and valet assistance' },
          { id: 11, name: 'Pool & Recreation', prompt: 'Swimming pool and recreational facilities' },
          { id: 12, name: 'Fitness Center', prompt: 'Hotel gym and fitness facilities' },
          { id: 13, name: 'Business Center', prompt: 'Business services and meeting support' },
          { id: 14, name: 'Guest Relations', prompt: 'Customer service and guest satisfaction' },
          { id: 15, name: 'Catering Services', prompt: 'Event catering and food service' },
          { id: 16, name: 'Transportation', prompt: 'Airport shuttle and transportation services' },
          { id: 17, name: 'Entertainment', prompt: 'Hotel entertainment and activities' },
          { id: 18, name: 'Security Services', prompt: 'Guest safety and security measures' },
          { id: 19, name: 'Maintenance', prompt: 'Facility maintenance and upkeep' },
          { id: 20, name: 'Guest Experience', prompt: 'Memorable guest experience and hospitality' }
        ]
      }
    }
  },
  'Fitness & Wellness': {
    title: 'Fitness & Wellness Categories',
    categories: {
      fitness: {
        name: 'Fitness & Exercise',
        icon: '💪',
        items: [
          { id: 1, name: 'Gym Workout', prompt: 'Modern gym with fitness equipment and training' },
          { id: 2, name: 'Personal Training', prompt: 'One-on-one personal trainer session' },
          { id: 3, name: 'Group Classes', prompt: 'Energetic group fitness class' },
          { id: 4, name: 'Cardio Training', prompt: 'Cardiovascular exercise and equipment' },
          { id: 5, name: 'Strength Training', prompt: 'Weight lifting and strength building' },
          { id: 6, name: 'Yoga Practice', prompt: 'Peaceful yoga session and meditation' },
          { id: 7, name: 'Pilates Class', prompt: 'Pilates exercise and core strengthening' },
          { id: 8, name: 'CrossFit Training', prompt: 'High-intensity CrossFit workout' },
          { id: 9, name: 'Running Track', prompt: 'Outdoor running and track athletics' },
          { id: 10, name: 'Swimming Pool', prompt: 'Swimming laps and aquatic fitness' },
          { id: 11, name: 'Cycling Class', prompt: 'Indoor cycling and spin class' },
          { id: 12, name: 'Martial Arts', prompt: 'Martial arts training and self-defense' },
          { id: 13, name: 'Dance Fitness', prompt: 'Dance-based fitness and Zumba' },
          { id: 14, name: 'Outdoor Fitness', prompt: 'Outdoor workout and boot camp' },
          { id: 15, name: 'Functional Training', prompt: 'Functional movement and athletic training' },
          { id: 16, name: 'Rehabilitation', prompt: 'Physical therapy and injury recovery' },
          { id: 17, name: 'Senior Fitness', prompt: 'Age-appropriate fitness for seniors' },
          { id: 18, name: 'Youth Sports', prompt: 'Children and teen fitness programs' },
          { id: 19, name: 'Fitness Assessment', prompt: 'Body composition and fitness testing' },
          { id: 20, name: 'Recovery Session', prompt: 'Post-workout recovery and stretching' }
        ]
      },
      wellness: {
        name: 'Health & Wellness',
        icon: '🧘',
        items: [
          { id: 1, name: 'Meditation', prompt: 'Peaceful meditation and mindfulness practice' },
          { id: 2, name: 'Spa Treatment', prompt: 'Relaxing spa therapy and massage' },
          { id: 3, name: 'Nutrition Counseling', prompt: 'Healthy eating and nutrition guidance' },
          { id: 4, name: 'Mental Health', prompt: 'Mental wellness and therapy support' },
          { id: 5, name: 'Wellness Coaching', prompt: 'Holistic wellness and lifestyle coaching' },
          { id: 6, name: 'Stress Management', prompt: 'Stress relief and relaxation techniques' },
          { id: 7, name: 'Sleep Wellness', prompt: 'Sleep hygiene and rest optimization' },
          { id: 8, name: 'Detox Programs', prompt: 'Body detox and cleansing programs' },
          { id: 9, name: 'Aromatherapy', prompt: 'Essential oils and aromatherapy treatment' },
          { id: 10, name: 'Acupuncture', prompt: 'Traditional acupuncture therapy' },
          { id: 11, name: 'Chiropractic Care', prompt: 'Spinal adjustment and chiropractic treatment' },
          { id: 12, name: 'Massage Therapy', prompt: 'Therapeutic massage and bodywork' },
          { id: 13, name: 'Healthy Cooking', prompt: 'Nutritious meal preparation and cooking' },
          { id: 14, name: 'Supplement Guide', prompt: 'Vitamins and nutritional supplements' },
          { id: 15, name: 'Wellness Retreat', prompt: 'Wellness retreat and spa getaway' },
          { id: 16, name: 'Mindfulness Training', prompt: 'Mindfulness and awareness practices' },
          { id: 17, name: 'Holistic Health', prompt: 'Integrative and holistic health approaches' },
          { id: 18, name: 'Preventive Care', prompt: 'Preventive health screening and care' },
          { id: 19, name: 'Wellness Technology', prompt: 'Health tracking and wellness apps' },
          { id: 20, name: 'Community Wellness', prompt: 'Group wellness programs and support' }
        ]
      }
    }
  },
  'Legal Services': {
    title: 'Legal Categories',
    categories: {
      practice: {
        name: 'Legal Practice Areas',
        icon: '⚖️',
        items: [
          { id: 1, name: 'Corporate Law', prompt: 'Business law and corporate legal services' },
          { id: 2, name: 'Family Law', prompt: 'Divorce, custody, and family legal matters' },
          { id: 3, name: 'Criminal Defense', prompt: 'Criminal law defense and representation' },
          { id: 4, name: 'Personal Injury', prompt: 'Accident and injury legal claims' },
          { id: 5, name: 'Real Estate Law', prompt: 'Property transactions and real estate legal' },
          { id: 6, name: 'Employment Law', prompt: 'Workplace rights and employment legal issues' },
          { id: 7, name: 'Immigration Law', prompt: 'Visa, citizenship, and immigration services' },
          { id: 8, name: 'Intellectual Property', prompt: 'Patents, trademarks, and IP protection' },
          { id: 9, name: 'Estate Planning', prompt: 'Wills, trusts, and estate legal planning' },
          { id: 10, name: 'Bankruptcy Law', prompt: 'Debt relief and bankruptcy proceedings' },
          { id: 11, name: 'Tax Law', prompt: 'Tax planning and IRS representation' },
          { id: 12, name: 'Contract Law', prompt: 'Contract drafting and dispute resolution' },
          { id: 13, name: 'Medical Malpractice', prompt: 'Healthcare negligence and malpractice claims' },
          { id: 14, name: 'Environmental Law', prompt: 'Environmental regulations and compliance' },
          { id: 15, name: 'Securities Law', prompt: 'Investment and securities legal matters' },
          { id: 16, name: 'Civil Rights', prompt: 'Civil liberties and discrimination cases' },
          { id: 17, name: 'Consumer Protection', prompt: 'Consumer rights and fraud protection' },
          { id: 18, name: 'Administrative Law', prompt: 'Government agency and regulatory law' },
          { id: 19, name: 'International Law', prompt: 'Cross-border and international legal matters' },
          { id: 20, name: 'Appellate Law', prompt: 'Appeals and higher court proceedings' }
        ]
      },
      services: {
        name: 'Legal Services',
        icon: '📋',
        items: [
          { id: 1, name: 'Legal Consultation', prompt: 'Attorney consultation and legal advice' },
          { id: 2, name: 'Document Drafting', prompt: 'Legal document preparation and review' },
          { id: 3, name: 'Court Representation', prompt: 'Courtroom litigation and trial advocacy' },
          { id: 4, name: 'Mediation Services', prompt: 'Alternative dispute resolution and mediation' },
          { id: 5, name: 'Legal Research', prompt: 'Case law research and legal analysis' },
          { id: 6, name: 'Compliance Review', prompt: 'Regulatory compliance and risk assessment' },
          { id: 7, name: 'Notary Services', prompt: 'Document notarization and authentication' },
          { id: 8, name: 'Legal Filing', prompt: 'Court filings and legal document submission' },
          { id: 9, name: 'Client Counseling', prompt: 'Legal guidance and client advisory services' },
          { id: 10, name: 'Settlement Negotiation', prompt: 'Dispute settlement and negotiation' },
          { id: 11, name: 'Due Diligence', prompt: 'Business transaction due diligence' },
          { id: 12, name: 'Legal Training', prompt: 'Corporate legal training and education' },
          { id: 13, name: 'Paralegal Support', prompt: 'Paralegal assistance and case support' },
          { id: 14, name: 'Legal Technology', prompt: 'Legal software and case management systems' },
          { id: 15, name: 'Client Communication', prompt: 'Attorney-client communication and updates' },
          { id: 16, name: 'Case Management', prompt: 'Legal case organization and tracking' },
          { id: 17, name: 'Expert Witnesses', prompt: 'Expert testimony and witness preparation' },
          { id: 18, name: 'Legal Ethics', prompt: 'Professional responsibility and legal ethics' },
          { id: 19, name: 'Pro Bono Work', prompt: 'Community service and pro bono legal aid' },
          { id: 20, name: 'Legal Marketing', prompt: 'Law firm marketing and client development' }
        ]
      }
    }
  },
  'E-commerce': {
    title: 'E-commerce Categories',
    categories: {
      online: {
        name: 'Online Store & Platform',
        icon: '🛒',
        items: [
          { id: 1, name: 'Website Design', prompt: 'Modern e-commerce website interface and design' },
          { id: 2, name: 'Product Catalog', prompt: 'Online product catalog and inventory display' },
          { id: 3, name: 'Shopping Cart', prompt: 'User-friendly shopping cart and checkout process' },
          { id: 4, name: 'Mobile App', prompt: 'E-commerce mobile application interface' },
          { id: 5, name: 'Payment Gateway', prompt: 'Secure online payment processing system' },
          { id: 6, name: 'Customer Reviews', prompt: 'Product reviews and rating system' },
          { id: 7, name: 'Search Function', prompt: 'Advanced product search and filtering' },
          { id: 8, name: 'Wishlist Feature', prompt: 'Customer wishlist and favorites' },
          { id: 9, name: 'Recommendation Engine', prompt: 'AI-powered product recommendations' },
          { id: 10, name: 'Live Chat Support', prompt: 'Customer service chat and support' },
          { id: 11, name: 'Order Tracking', prompt: 'Package tracking and delivery updates' },
          { id: 12, name: 'Inventory Management', prompt: 'Stock management and warehouse system' },
          { id: 13, name: 'Multi-vendor Platform', prompt: 'Marketplace with multiple sellers' },
          { id: 14, name: 'Social Commerce', prompt: 'Social media integrated shopping' },
          { id: 15, name: 'Subscription Service', prompt: 'Recurring subscription and billing' },
          { id: 16, name: 'Digital Downloads', prompt: 'Digital product delivery system' },
          { id: 17, name: 'International Shipping', prompt: 'Global shipping and logistics' },
          { id: 18, name: 'Return Policy', prompt: 'Easy returns and refund process' },
          { id: 19, name: 'Loyalty Program', prompt: 'Customer loyalty and rewards system' },
          { id: 20, name: 'Analytics Dashboard', prompt: 'Sales analytics and performance metrics' }
        ]
      },
      marketing: {
        name: 'Digital Marketing',
        icon: '📈',
        items: [
          { id: 1, name: 'SEO Optimization', prompt: 'Search engine optimization and ranking' },
          { id: 2, name: 'Social Media Ads', prompt: 'Social media advertising campaigns' },
          { id: 3, name: 'Email Marketing', prompt: 'Email campaigns and newsletter marketing' },
          { id: 4, name: 'Influencer Marketing', prompt: 'Influencer partnerships and collaborations' },
          { id: 5, name: 'Content Marketing', prompt: 'Blog content and marketing materials' },
          { id: 6, name: 'PPC Advertising', prompt: 'Pay-per-click advertising campaigns' },
          { id: 7, name: 'Affiliate Program', prompt: 'Affiliate marketing and partnerships' },
          { id: 8, name: 'Video Marketing', prompt: 'Product videos and marketing content' },
          { id: 9, name: 'Retargeting Ads', prompt: 'Remarketing and retargeting campaigns' },
          { id: 10, name: 'Brand Building', prompt: 'Brand identity and recognition building' },
          { id: 11, name: 'Customer Acquisition', prompt: 'New customer acquisition strategies' },
          { id: 12, name: 'Conversion Optimization', prompt: 'Website conversion rate optimization' },
          { id: 13, name: 'Market Research', prompt: 'Consumer behavior and market analysis' },
          { id: 14, name: 'Competitor Analysis', prompt: 'Competitive intelligence and benchmarking' },
          { id: 15, name: 'Product Launch', prompt: 'New product launch and promotion' },
          { id: 16, name: 'Seasonal Campaigns', prompt: 'Holiday and seasonal marketing' },
          { id: 17, name: 'Customer Retention', prompt: 'Customer loyalty and retention strategies' },
          { id: 18, name: 'A/B Testing', prompt: 'Marketing campaign testing and optimization' },
          { id: 19, name: 'Cross-selling', prompt: 'Upselling and cross-selling techniques' },
          { id: 20, name: 'Marketing Automation', prompt: 'Automated marketing workflows and funnels' }
        ]
      }
    }
  },
  'Automotive': {
    title: 'Automotive Categories',
    categories: {
      vehicles: {
        name: 'Vehicles & Models',
        icon: '🚗',
        items: [
          { id: 1, name: 'Luxury Cars', prompt: 'Premium luxury vehicles and high-end automobiles' },
          { id: 2, name: 'Electric Vehicles', prompt: 'Modern electric cars and sustainable transportation' },
          { id: 3, name: 'SUVs & Trucks', prompt: 'Sport utility vehicles and pickup trucks' },
          { id: 4, name: 'Sports Cars', prompt: 'High-performance sports and racing vehicles' },
          { id: 5, name: 'Family Sedans', prompt: 'Comfortable family cars and sedans' },
          { id: 6, name: 'Motorcycles', prompt: 'Motorcycles and two-wheeled vehicles' },
          { id: 7, name: 'Commercial Vehicles', prompt: 'Delivery trucks and commercial fleet' },
          { id: 8, name: 'Classic Cars', prompt: 'Vintage and classic automobile collection' },
          { id: 9, name: 'Hybrid Vehicles', prompt: 'Fuel-efficient hybrid cars and technology' },
          { id: 10, name: 'Compact Cars', prompt: 'Small and economical city cars' },
          { id: 11, name: 'Convertibles', prompt: 'Open-top convertible vehicles' },
          { id: 12, name: 'Off-Road Vehicles', prompt: '4x4 and off-road adventure vehicles' },
          { id: 13, name: 'Autonomous Cars', prompt: 'Self-driving and autonomous vehicle technology' },
          { id: 14, name: 'Racing Cars', prompt: 'Professional racing and motorsport vehicles' },
          { id: 15, name: 'Concept Cars', prompt: 'Futuristic concept and prototype vehicles' },
          { id: 16, name: 'Minivans', prompt: 'Family minivans and people carriers' },
          { id: 17, name: 'Crossovers', prompt: 'Crossover SUVs and versatile vehicles' },
          { id: 18, name: 'Pickup Trucks', prompt: 'Work trucks and utility pickup vehicles' },
          { id: 19, name: 'Luxury SUVs', prompt: 'Premium luxury sport utility vehicles' },
          { id: 20, name: 'City Cars', prompt: 'Urban commuter and city driving vehicles' }
        ]
      },
      bikeParts: {
        name: 'Bike Spare Parts',
        icon: '🏍️',
        items: [
          { id: 1, name: 'Engine Parts', prompt: 'Motorcycle engine components and cylinder parts for Honda Crown and Pakistani bikes' },
          { id: 2, name: 'Brake Pads', prompt: 'High-quality brake pads and disc brakes for motorcycles' },
          { id: 3, name: 'Chain & Sprocket', prompt: 'Drive chain and sprocket set for Honda 70, 125 models' },
          { id: 4, name: 'Oil Filter', prompt: 'Engine oil filter for Honda Crown, CD70, CG125' },
          { id: 5, name: 'Air Filter', prompt: 'Air filter element for Pakistani motorcycles' },
          { id: 6, name: 'Spark Plug', prompt: 'Spark plugs for Honda and local bike models' },
          { id: 7, name: 'Clutch Plates', prompt: 'Clutch plate set for Honda Crown and CG125' },
          { id: 8, name: 'Carburetor', prompt: 'Motorcycle carburetor for Honda bikes' },
          { id: 9, name: 'Battery', prompt: '12V motorcycle battery for local bikes' },
          { id: 10, name: 'Headlight Assembly', prompt: 'Front headlight and indicator lights' },
          { id: 11, name: 'Rear Shockers', prompt: 'Rear shock absorbers for comfortable ride' },
          { id: 12, name: 'Front Fork', prompt: 'Front suspension fork assembly' },
          { id: 13, name: 'Handlebar', prompt: 'Motorcycle handlebar and grips' },
          { id: 14, name: 'Seat Cover', prompt: 'Waterproof bike seat cover' },
          { id: 15, name: 'Tires & Tubes', prompt: 'Motorcycle tires and inner tubes for Honda models' },
          { id: 16, name: 'Mudguard', prompt: 'Front and rear mudguard fender' },
          { id: 17, name: 'Fuel Tank', prompt: 'Motorcycle petrol tank for Honda Crown' },
          { id: 18, name: 'Side Mirror', prompt: 'Rearview side mirrors pair' },
          { id: 19, name: 'Speedometer', prompt: 'Analog or digital speedometer gauge' },
          { id: 20, name: 'Exhaust Pipe', prompt: 'Silencer and exhaust system for bikes' },
          { id: 21, name: 'Piston Kit', prompt: 'Engine piston and rings kit' },
          { id: 22, name: 'Foot Rest', prompt: 'Rider and pillion footrest set' },
          { id: 23, name: 'Brake Cable', prompt: 'Front and rear brake cable wire' },
          { id: 24, name: 'Accelerator Cable', prompt: 'Throttle cable for smooth acceleration' },
          { id: 25, name: 'Horn', prompt: 'Electric horn for motorcycles' },
          { id: 26, name: 'Fuel Cock', prompt: 'Petrol fuel tap and cock' },
          { id: 27, name: 'Kick Starter', prompt: 'Kick start lever assembly' },
          { id: 28, name: 'Clutch Lever', prompt: 'Left side clutch lever handle' },
          { id: 29, name: 'Brake Lever', prompt: 'Right side brake lever handle' },
          { id: 30, name: 'Chain Cover', prompt: 'Protective chain guard cover' }
        ]
      },
      services: {
        name: 'Automotive Services',
        icon: '🔧',
        items: [
          { id: 1, name: 'Auto Repair', prompt: 'Professional automotive repair and maintenance' },
          { id: 2, name: 'Oil Change', prompt: 'Quick oil change and fluid services' },
          { id: 3, name: 'Tire Service', prompt: 'Tire installation, rotation, and repair' },
          { id: 4, name: 'Car Wash', prompt: 'Professional car washing and detailing' },
          { id: 5, name: 'Engine Diagnostics', prompt: 'Computer diagnostics and engine analysis' },
          { id: 6, name: 'Brake Service', prompt: 'Brake repair and safety inspection' },
          { id: 7, name: 'Auto Insurance', prompt: 'Vehicle insurance and coverage options' },
          { id: 8, name: 'Car Dealership', prompt: 'New and used car sales showroom' },
          { id: 9, name: 'Auto Parts', prompt: 'Replacement parts and automotive accessories' },
          { id: 10, name: 'Roadside Assistance', prompt: 'Emergency roadside help and towing' },
          { id: 11, name: 'Car Rental', prompt: 'Vehicle rental and leasing services' },
          { id: 12, name: 'Auto Financing', prompt: 'Car loans and financing options' },
          { id: 13, name: 'Collision Repair', prompt: 'Accident damage and collision repair' },
          { id: 14, name: 'Performance Tuning', prompt: 'Engine tuning and performance upgrades' },
          { id: 15, name: 'Auto Inspection', prompt: 'Safety inspection and emissions testing' },
          { id: 16, name: 'Car Customization', prompt: 'Vehicle modification and customization' },
          { id: 17, name: 'Fleet Management', prompt: 'Commercial fleet services and management' },
          { id: 18, name: 'Auto Glass', prompt: 'Windshield repair and glass replacement' },
          { id: 19, name: 'Car Storage', prompt: 'Vehicle storage and parking services' },
          { id: 20, name: 'Driving School', prompt: 'Driver education and training services' }
        ]
      }
    }
  },
  'Digital Marketing': {
    title: 'Marketing Campaign Creator',
    categories: {
      campaign: {
        name: 'Step 1: Campaign Type',
        icon: '🎯',
        items: [
          { id: 1, name: 'Product Launch', icon: '🚀', prompt: 'exciting new product reveal with dramatic unveiling atmosphere, featuring the product as hero element with launch energy and innovation vibes' },
          { id: 2, name: 'Brand Campaign', icon: '🎨', prompt: 'strong brand identity showcase with memorable visual storytelling, emphasizing brand values, personality and unique positioning' },
          { id: 3, name: 'Seasonal Offer', icon: '🎄', prompt: 'festive seasonal promotion with holiday-themed elements, special offers, limited-time deals, and celebratory atmosphere' },
          { id: 4, name: 'Flash Sale', icon: '⚡', prompt: 'urgent limited-time sale with bold discount messaging, countdown urgency, explosive deals, and immediate action triggers' },
          { id: 5, name: 'Grand Opening', icon: '🎉', prompt: 'celebratory grand opening event with ribbon cutting vibes, welcome atmosphere, special launch offers, and excitement energy' },
          { id: 6, name: 'Event Promotion', icon: '📅', prompt: 'dynamic event announcement with date, venue highlights, speaker or performer showcase, and compelling attendance call-to-action' },
          { id: 7, name: 'Social Media Post', icon: '📱', prompt: 'scroll-stopping social media content with engaging visuals, shareable messaging, platform-optimized format, and viral potential' },
          { id: 8, name: 'Advertisement', icon: '📺', prompt: 'attention-grabbing advertisement with clear product benefits, persuasive messaging, strong call-to-action, and memorable hook' },
          { id: 9, name: 'Email Campaign', icon: '✉️', prompt: 'email-friendly marketing design with clear hierarchy, compelling subject line visual, scannable content, and clickable CTA buttons' },
          { id: 10, name: 'Testimonial', icon: '⭐', prompt: 'authentic customer review showcase with 5-star ratings, real testimonials, trust-building quotes, and social proof elements' },
          { id: 11, name: 'Announcement', icon: '📢', prompt: 'important company update with news-worthy information, professional announcement tone, key highlights, and stakeholder focus' },
          { id: 12, name: 'Contest/Giveaway', icon: '🎁', prompt: 'exciting prize giveaway promotion with attractive rewards display, entry instructions, winner excitement, and participation incentives' },
          { id: 13, name: 'Loyalty Program', icon: '💎', prompt: 'exclusive rewards program showcase with VIP benefits, points system, member perks, and premium tier advantages' },
          { id: 14, name: 'Referral Program', icon: '🤝', prompt: 'friend referral incentive with mutual benefits, easy sharing options, reward structure, and community growth messaging' },
          { id: 15, name: 'Partnership', icon: '🔗', prompt: 'collaborative partnership announcement with both brand logos, synergy messaging, combined strength, and mutual value proposition' },
          { id: 16, name: 'Milestone', icon: '🏆', prompt: 'achievement celebration with impressive numbers, growth metrics, thank you messaging, and community appreciation' },
          { id: 17, name: 'Recruitment', icon: '👥', prompt: 'career opportunity showcase with company culture, job benefits, team environment, growth potential, and application call-to-action' },
          { id: 18, name: 'CSR Initiative', icon: '🌱', prompt: 'social responsibility campaign with environmental or community impact, purpose-driven messaging, and positive change narrative' },
          { id: 19, name: 'Tutorial/Guide', icon: '📚', prompt: 'educational how-to content with step-by-step visuals, learning value, helpful tips, and skill-building focus' },
          { id: 20, name: 'Behind Scenes', icon: '🎬', prompt: 'authentic behind-the-scenes peek with production process, team at work, raw moments, and transparency storytelling' }
        ]
      },
      contentType: {
        name: 'Step 2: Content Type',
        icon: '📝',
        items: [
          { id: 1, name: 'Infographic', icon: '📊', prompt: 'information-rich infographic layout with charts, graphs, icons, data visualization, clear sections, and easy-to-scan statistics' },
          { id: 2, name: 'Quote Card', icon: '💬', prompt: 'inspirational quote design with elegant typography, attribution, decorative elements, quotation marks, and motivational aesthetic' },
          { id: 3, name: 'Product Showcase', icon: '🛍️', prompt: 'product-focused display with hero product shot, feature highlights, benefits callouts, premium presentation, and lifestyle context' },
          { id: 4, name: 'Carousel Post', icon: '🎠', prompt: 'swipeable carousel slide design with consistent layout, numbered sequence, visual continuity, story flow, and engaging progression' },
          { id: 5, name: 'Video Thumbnail', icon: '🎥', prompt: 'eye-catching video thumbnail with play button, compelling preview frame, curiosity-generating visuals, and click-worthy composition' },
          { id: 6, name: 'Story Graphic', icon: '📲', prompt: 'vertical 9:16 story format with mobile-first design, thumb-stopping visuals, text overlay, stickers, and interactive elements' },
          { id: 7, name: 'Comparison Chart', icon: '⚖️', prompt: 'side-by-side comparison layout with before/after, versus format, pros/cons, feature matrix, and clear differentiation' },
          { id: 8, name: 'Tip & Tricks', icon: '💡', prompt: 'helpful tips layout with numbered points, light bulb icons, actionable advice, quick wins, and valuable insights presentation' },
          { id: 9, name: 'Statistics Post', icon: '📈', prompt: 'data-driven statistics display with bold numbers, percentage growth, trend arrows, key metrics, and impactful data points' },
          { id: 10, name: 'Customer Review', icon: '⭐', prompt: 'testimonial card with customer photo, 5-star rating, authentic review quote, name/title, and trust-building layout' },
          { id: 11, name: 'Event Banner', icon: '🎪', prompt: 'event promotion banner with date/time/location, speaker/performer, registration CTA, venue imagery, and exciting atmosphere' },
          { id: 12, name: 'Discount Offer', icon: '🏷️', prompt: 'promotional offer design with percentage off, sale badge, limited time urgency, savings highlight, and attractive price display' },
          { id: 13, name: 'Poll/Survey', icon: '📋', prompt: 'interactive poll graphic with question, multiple choice options, voting interface, results preview, and engagement invitation' },
          { id: 14, name: 'FAQ Card', icon: '❓', prompt: 'question and answer format with Q&A layout, helpful information, clear typography, organized sections, and problem-solving focus' },
          { id: 15, name: 'Case Study', icon: '📑', prompt: 'success story layout with client logo, challenge/solution/results, metrics, testimonial quote, and compelling narrative arc' },
          { id: 16, name: 'Team Spotlight', icon: '👔', prompt: 'employee feature with professional headshot, name/title, fun facts, achievements, personality showcase, and humanizing content' },
          { id: 17, name: 'Promo Code', icon: '🎟️', prompt: 'promotional code graphic with coupon design, discount code display, copy-friendly format, expiration date, and redemption instructions' },
          { id: 18, name: 'How-To Guide', icon: '📖', prompt: 'step-by-step tutorial with numbered instructions, process flow, visual demonstrations, helpful illustrations, and educational layout' },
          { id: 19, name: 'Meme/Humor', icon: '😄', prompt: 'funny meme format with relatable humor, trending template, witty caption, shareable comedy, and entertainment value' },
          { id: 20, name: 'CTA Banner', icon: '👆', prompt: 'call-to-action focused design with prominent button, action-oriented copy, urgency messaging, clickable appearance, and conversion focus' }
        ]
      },
      designStyle: {
        name: 'Step 3: Design Style',
        icon: '🎨',
        items: [
          { id: 1, name: 'Minimalist', icon: '⚪', prompt: 'ultra-clean minimalist design with white space, simple typography, zen aesthetic, less-is-more philosophy, elegant simplicity, and focus on essential elements only' },
          { id: 2, name: 'Bold & Vibrant', icon: '🌈', prompt: 'bold vibrant colors with high contrast, energetic palette, eye-catching saturated hues, dynamic color blocking, attention-grabbing vibrancy, and electric energy' },
          { id: 3, name: 'Professional', icon: '💼', prompt: 'corporate professional aesthetic with business polish, credible appearance, sophisticated layout, trustworthy design, clean executive style, and enterprise quality' },
          { id: 4, name: 'Modern', icon: '✨', prompt: 'modern contemporary design with current trends, sleek interfaces, up-to-date styling, fresh aesthetic, cutting-edge visuals, and zeitgeist appeal' },
          { id: 5, name: 'Elegant', icon: '👑', prompt: 'elegant luxury aesthetic with refined sophistication, premium feel, high-end styling, graceful composition, upscale presentation, and timeless class' },
          { id: 6, name: 'Playful', icon: '🎈', prompt: 'fun playful design with whimsical elements, cheerful colors, lighthearted tone, joyful energy, entertaining visuals, and youthful spirit' },
          { id: 7, name: 'Vintage', icon: '📻', prompt: 'retro vintage aesthetic with nostalgic appeal, classic typography, aged textures, throwback styling, old-school charm, and timeless heritage' },
          { id: 8, name: 'Futuristic', icon: '🚀', prompt: 'futuristic sci-fi design with tech-forward aesthetics, digital innovation vibes, next-generation styling, space-age elements, and cutting-edge future vision' },
          { id: 9, name: 'Gradient', icon: '🌅', prompt: 'smooth gradient design with color transitions, blended hues, ombre effects, flowing color spectrum, seamless shifts, and dimensional color depth' },
          { id: 10, name: 'Monochrome', icon: '⚫', prompt: 'black and white monochrome with grayscale palette, high contrast, dramatic shadows, timeless noir aesthetic, classic simplicity, and powerful minimalism' },
          { id: 11, name: 'Pastel', icon: '🦄', prompt: 'soft pastel colors with muted tones, gentle palette, dreamy aesthetic, soothing hues, subtle beauty, delicate color harmony, and calming visuals' },
          { id: 12, name: 'Dark Mode', icon: '🌙', prompt: 'dark theme design with deep backgrounds, light text contrast, modern dark UI, sleek nighttime aesthetic, reduced eye strain, and sophisticated darkness' },
          { id: 13, name: 'Neon', icon: '💡', prompt: 'bright neon design with glowing colors, electric vibes, cyberpunk aesthetics, luminous highlights, vivid fluorescent palette, and nightclub energy' },
          { id: 14, name: 'Nature', icon: '🌿', prompt: 'natural organic design with earthy tones, botanical elements, eco-friendly aesthetic, sustainable vibes, natural textures, and environmental harmony' },
          { id: 15, name: 'Abstract', icon: '🎭', prompt: 'abstract artistic design with creative shapes, non-representational forms, avant-garde styling, expressive composition, artistic freedom, and conceptual visuals' },
          { id: 16, name: 'Geometric', icon: '📐', prompt: 'geometric pattern design with shapes and angles, mathematical precision, structured layout, tessellation effects, clean lines, and architectural aesthetics' },
          { id: 17, name: 'Watercolor', icon: '🎨', prompt: 'watercolor artistic style with painted textures, fluid strokes, artistic softness, hand-painted feel, dreamy blends, and creative illustration' },
          { id: 18, name: '3D Style', icon: '🔮', prompt: '3D rendered design with dimensional depth, realistic shadows, volumetric lighting, spatial layers, tactile appearance, and immersive perspective' },
          { id: 19, name: 'Flat Design', icon: '📱', prompt: 'flat 2D design with no shadows, simple shapes, clean icons, modern flatness, vector aesthetic, and straightforward visual hierarchy' },
          { id: 20, name: 'Hand-drawn', icon: '✏️', prompt: 'hand-drawn sketch style with illustrated elements, artistic imperfections, personal touch, doodle aesthetics, authentic creativity, and handcrafted feel' }
        ]
      }
    }
  },
  'Medical': {
    title: 'Medical Categories',
    categories: {
      services: {
        name: 'Medical Services',
        icon: '🏥',
        items: [
          { id: 1, name: 'Doctor Consultation', prompt: 'Doctor consulting with patient' },
          { id: 2, name: 'Surgery Room', prompt: 'Modern surgical operation theater' },
          { id: 3, name: 'Emergency Care', prompt: 'Emergency room medical care' },
          { id: 4, name: 'Patient Care', prompt: 'Nurse caring for patient' },
          { id: 5, name: 'Medical Examination', prompt: 'Physical examination checkup' },
          { id: 6, name: 'Laboratory Testing', prompt: 'Medical lab testing facility' },
          { id: 7, name: 'Radiology', prompt: 'X-ray and imaging department' },
          { id: 8, name: 'Pharmacy', prompt: 'Hospital pharmacy dispensary' },
          { id: 9, name: 'Physical Therapy', prompt: 'Physiotherapy rehabilitation session' },
          { id: 10, name: 'Mental Health', prompt: 'Counseling therapy session' },
          { id: 11, name: 'Pediatric Care', prompt: 'Children healthcare services' },
          { id: 12, name: 'Maternity Ward', prompt: 'Maternity and childbirth care' },
          { id: 13, name: 'ICU', prompt: 'Intensive care unit facility' },
          { id: 14, name: 'Cardiology', prompt: 'Heart care cardiology center' },
          { id: 15, name: 'Dental Care', prompt: 'Dental clinic treatment' },
          { id: 16, name: 'Eye Care', prompt: 'Ophthalmology eye examination' },
          { id: 17, name: 'Vaccination', prompt: 'Immunization vaccine administration' },
          { id: 18, name: 'Home Healthcare', prompt: 'At-home medical care service' },
          { id: 19, name: 'Telemedicine', prompt: 'Virtual online medical consultation' },
          { id: 20, name: 'Medical Research', prompt: 'Clinical research laboratory' }
        ]
      },
      equipment: {
        name: 'Medical Equipment',
        icon: '🩺',
        items: [
          { id: 1, name: 'Stethoscope', prompt: 'Professional medical stethoscope' },
          { id: 2, name: 'MRI Machine', prompt: 'Advanced MRI scanning equipment' },
          { id: 3, name: 'CT Scanner', prompt: 'CT scan imaging machine' },
          { id: 4, name: 'Ultrasound', prompt: 'Ultrasound scanning device' },
          { id: 5, name: 'ECG Monitor', prompt: 'Heart monitoring ECG machine' },
          { id: 6, name: 'Ventilator', prompt: 'Medical breathing ventilator' },
          { id: 7, name: 'Defibrillator', prompt: 'Emergency defibrillator device' },
          { id: 8, name: 'Surgical Tools', prompt: 'Sterile surgical instruments' },
          { id: 9, name: 'IV Stand', prompt: 'Intravenous drip equipment' },
          { id: 10, name: 'Hospital Bed', prompt: 'Adjustable medical hospital bed' },
          { id: 11, name: 'Wheelchair', prompt: 'Medical wheelchair equipment' },
          { id: 12, name: 'Oxygen Tank', prompt: 'Medical oxygen supply system' },
          { id: 13, name: 'Blood Pressure Monitor', prompt: 'BP measurement device' },
          { id: 14, name: 'Thermometer', prompt: 'Digital medical thermometer' },
          { id: 15, name: 'Microscope', prompt: 'Laboratory research microscope' },
          { id: 16, name: 'X-Ray Machine', prompt: 'Radiography X-ray equipment' },
          { id: 17, name: 'Incubator', prompt: 'Neonatal care incubator' },
          { id: 18, name: 'Autoclave', prompt: 'Medical sterilization equipment' },
          { id: 19, name: 'PPE Kit', prompt: 'Personal protective equipment set' },
          { id: 20, name: 'Medical Cart', prompt: 'Mobile medical supply cart' }
        ]
      }
    }
  },
  'Entertainment': {
    title: 'Entertainment Categories',
    categories: {
      media: {
        name: 'Media & Production',
        icon: '🎬',
        items: [
          { id: 1, name: 'Movie Production', prompt: 'Film production and movie making process' },
          { id: 2, name: 'TV Shows', prompt: 'Television production and broadcasting' },
          { id: 3, name: 'Music Recording', prompt: 'Music studio recording and production' },
          { id: 4, name: 'Live Concert', prompt: 'Live music performance and concert venue' },
          { id: 5, name: 'Theater Performance', prompt: 'Stage theater and dramatic performances' },
          { id: 6, name: 'Comedy Show', prompt: 'Stand-up comedy and entertainment venue' },
          { id: 7, name: 'Dance Performance', prompt: 'Dance shows and choreographed performances' },
          { id: 8, name: 'Podcast Studio', prompt: 'Podcast recording and audio production' },
          { id: 9, name: 'Video Games', prompt: 'Gaming industry and video game development' },
          { id: 10, name: 'Streaming Platform', prompt: 'Online streaming and digital content' },
          { id: 11, name: 'Animation Studio', prompt: 'Animation production and cartoon creation' },
          { id: 12, name: 'Documentary Film', prompt: 'Documentary filmmaking and storytelling' },
          { id: 13, name: 'Music Video', prompt: 'Music video production and creative direction' },
          { id: 14, name: 'Radio Broadcasting', prompt: 'Radio station and audio broadcasting' },
          { id: 15, name: 'Voice Acting', prompt: 'Voice-over work and character dubbing' },
          { id: 16, name: 'Sound Design', prompt: 'Audio engineering and sound effects' },
          { id: 17, name: 'Film Editing', prompt: 'Post-production and video editing' },
          { id: 18, name: 'Cinematography', prompt: 'Camera work and visual storytelling' },
          { id: 19, name: 'Special Effects', prompt: 'VFX and special effects production' },
          { id: 20, name: 'Content Creation', prompt: 'Digital content and social media production' }
        ]
      },
      events: {
        name: 'Events & Venues',
        icon: '🎪',
        items: [
          { id: 1, name: 'Concert Venue', prompt: 'Music venue and concert hall atmosphere' },
          { id: 2, name: 'Festival Grounds', prompt: 'Music festival and outdoor event space' },
          { id: 3, name: 'Theater Venue', prompt: 'Performance theater and auditorium' },
          { id: 4, name: 'Comedy Club', prompt: 'Intimate comedy club and entertainment venue' },
          { id: 5, name: 'Sports Arena', prompt: 'Sports stadium and arena events' },
          { id: 6, name: 'Convention Center', prompt: 'Large convention and expo venue' },
          { id: 7, name: 'Nightclub', prompt: 'Dance club and nightlife entertainment' },
          { id: 8, name: 'Casino', prompt: 'Gaming casino and entertainment complex' },
          { id: 9, name: 'Amusement Park', prompt: 'Theme park rides and family entertainment' },
          { id: 10, name: 'Circus Show', prompt: 'Circus performance and acrobatic entertainment' },
          { id: 11, name: 'Magic Show', prompt: 'Magic performance and illusion entertainment' },
          { id: 12, name: 'Art Gallery', prompt: 'Art exhibition and gallery opening' },
          { id: 13, name: 'Museum Exhibit', prompt: 'Museum display and educational entertainment' },
          { id: 14, name: 'Escape Room', prompt: 'Interactive escape room and puzzle games' },
          { id: 15, name: 'Karaoke Bar', prompt: 'Karaoke entertainment and singing venue' },
          { id: 16, name: 'Bowling Alley', prompt: 'Bowling entertainment and recreational venue' },
          { id: 17, name: 'Arcade Games', prompt: 'Video arcade and gaming entertainment' },
          { id: 18, name: 'Drive-in Theater', prompt: 'Outdoor drive-in movie experience' },
          { id: 19, name: 'Wine Tasting', prompt: 'Wine tasting event and vineyard entertainment' },
          { id: 20, name: 'Corporate Events', prompt: 'Business entertainment and corporate parties' }
        ]
      }
    }
  }
};

// Industry-Specific Image Styles
const INDUSTRY_IMAGE_STYLES = {
  'Digital Marketing': [
    { id: 1, name: 'Typography Caption', icon: '✍️', style: 'Bold typography with text overlay, professional lettering integrated into image' },
    { id: 2, name: 'Social Media Post', icon: '📱', style: 'Social media optimized with vibrant colors and engaging layout' },
    { id: 3, name: 'Infographic Style', icon: '📊', style: 'Infographic design with data visualization and icons' },
    { id: 4, name: 'Quote Graphics', icon: '💬', style: 'Inspirational quote design with beautiful typography' },
    { id: 5, name: 'Banner Ad', icon: '🎯', style: 'Advertisement banner with call-to-action focus' },
    { id: 6, name: 'Minimalist Design', icon: '⚪', style: 'Clean minimalist design with negative space' },
    { id: 7, name: 'Photoshop Classic', icon: '🖼️', style: 'Classic Photoshop design aesthetic with layers, effects, vintage graphic design style from 2000s-2010s era' },
    { id: 8, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Food & Restaurant': [
    { id: 1, name: 'Menu Board Style', icon: '📋', style: 'Menu board presentation with elegant typography' },
    { id: 2, name: 'Overhead Flat Lay', icon: '📷', style: 'Top-down flat lay food photography' },
    { id: 3, name: 'Typography Food', icon: '✍️', style: 'Creative typography integrated with food elements' },
    { id: 4, name: 'Instagram Food', icon: '📱', style: 'Instagram-style trendy food photography' },
    { id: 5, name: 'Recipe Card', icon: '📝', style: 'Recipe card design with ingredients and steps' },
    { id: 6, name: 'Dark & Moody', icon: '🌙', style: 'Dark moody food photography with dramatic lighting, deep shadows, rich contrast' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' },
    { id: 8, name: 'Realistic Photo', icon: '📸', style: 'Ultra-realistic studio food photography with natural lighting, shallow depth of field' },
    { id: 9, name: 'Close-Up Macro', icon: '🔍', style: 'Extreme close-up macro food photography showing textures, steam, and fine details' },
    { id: 10, name: 'Bright & Airy', icon: '☀️', style: 'Bright airy food photography with white background, soft natural light, fresh clean look' },
    { id: 11, name: 'Rustic Traditional', icon: '🪵', style: 'Rustic traditional setting with wooden table, clay plates, cultural props, authentic atmosphere' },
    { id: 12, name: 'Minimalist', icon: '⚪', style: 'Minimalist clean composition, single plate focus, negative space, elegant simplicity' },
    { id: 13, name: 'Uber Eats Style', icon: '🍔', style: 'Uber Eats menu listing optimized food photography - clean bright white background, single hero dish perfectly centered, crisp top-lit studio lighting, vibrant appetizing colors, sharp focus on food details, app-card framing with generous negative space, absolutely NO text, NO logos, NO watermarks, NO props or clutter, photorealistic commercial food shot' },
    { id: 14, name: 'DoorDash Style', icon: '🚗', style: 'DoorDash menu card style food photography - bold appetizing hero shot at slight 30-degree angle, vibrant saturated colors with red/orange warm pop, clean light neutral background, centered single dish composition, crisp commercial studio lighting, mouth-watering steam and texture detail, absolutely NO text, NO logos, NO watermarks, optimized for DoorDash item listings' },
    { id: 15, name: 'Grubhub Style', icon: '🛵', style: 'Grubhub item listing food photography - warm inviting tones, centered single-dish hero composition on light clean surface, soft natural top-down lighting, rich appetizing color palette, well-lit textures and ingredient detail, professional commercial framing, absolutely NO text, NO logos, NO watermarks, NO cluttered props' },
    { id: 16, name: 'Zomato / Swiggy Style', icon: '🍽️', style: 'Zomato and Swiggy app listing food photography for Indian and Asian cuisine - richly saturated vibrant colors, 45-degree or top-down angle, hero single dish on neutral surface, dramatic appetizing lighting that highlights spices, sauces and textures, mouth-watering close framing, absolutely NO text, NO logos, NO watermarks, optimized for Zomato and Swiggy menu listings' },
    { id: 17, name: 'Delivery Storefront Banner', icon: '🎪', style: 'Wide storefront cover banner for delivery apps - spread of signature dishes arranged abundantly across a table, vibrant appetizing colors, professional editorial food photography with warm inviting lighting, cinematic 16:9 horizontal composition for Uber Eats, DoorDash, Grubhub and Zomato storefront headers, NO text overlays, NO logos, NO watermarks' }
  ],
  'Construction': [
    { id: 1, name: 'Blueprint Style', icon: '📐', style: 'Technical blueprint aesthetic with architectural lines' },
    { id: 2, name: 'Progress Documentation', icon: '📸', style: 'Professional progress documentation photography' },
    { id: 3, name: 'Before/After', icon: '🔄', style: 'Before and after comparison split view' },
    { id: 4, name: 'Safety Signage', icon: '⚠️', style: 'Safety signage style with bold warnings' },
    { id: 5, name: 'Aerial Drone', icon: '🚁', style: 'Aerial drone perspective bird eye view' },
    { id: 6, name: 'Project Timeline', icon: '📅', style: 'Timeline visualization with milestones' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Technology': [
    { id: 1, name: 'UI/UX Mockup', icon: '🖥️', style: 'User interface mockup design presentation' },
    { id: 2, name: 'Code Snippet', icon: '💻', style: 'Programming code snippet with syntax highlighting' },
    { id: 3, name: 'Data Visualization', icon: '📊', style: 'Data charts and graphs visualization' },
    { id: 4, name: 'Futuristic Hologram', icon: '🔮', style: 'Futuristic holographic technology aesthetic' },
    { id: 5, name: 'Tech Diagram', icon: '🔧', style: 'Technical diagram with connections and flow' },
    { id: 6, name: 'Neon Cyber', icon: '🌟', style: 'Neon cyberpunk tech aesthetic' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Healthcare': [
    { id: 1, name: 'Medical Infographic', icon: '📊', style: 'Medical infographic with health information' },
    { id: 2, name: 'Clean Clinical', icon: '🏥', style: 'Clean clinical medical photography' },
    { id: 3, name: 'Patient Education', icon: '📚', style: 'Educational medical illustration style' },
    { id: 4, name: 'Health Stats', icon: '📈', style: 'Health statistics and data visualization' },
    { id: 5, name: 'Caring Touch', icon: '❤️', style: 'Warm caring compassionate medical imagery' },
    { id: 6, name: 'Safety Protocol', icon: '⚕️', style: 'Medical safety protocol visualization' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Real Estate': [
    { id: 1, name: 'Virtual Tour', icon: '🏠', style: 'Virtual property tour perspective' },
    { id: 2, name: 'Luxury Lifestyle', icon: '✨', style: 'Luxury real estate lifestyle photography' },
    { id: 3, name: 'Floor Plan', icon: '📐', style: 'Architectural floor plan visualization' },
    { id: 4, name: 'Golden Hour', icon: '🌅', style: 'Golden hour natural lighting photography' },
    { id: 5, name: 'Interior Design', icon: '🛋️', style: 'Interior design magazine style' },
    { id: 6, name: 'Aerial Property', icon: '🚁', style: 'Aerial drone property overview' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Retail': [
    { id: 1, name: 'Product Typography', icon: '✍️', style: 'Product name in bold typography overlay' },
    { id: 2, name: 'E-commerce White', icon: '⚪', style: 'Clean white background product shot' },
    { id: 3, name: 'Lifestyle Context', icon: '✨', style: 'Product in lifestyle usage context' },
    { id: 4, name: 'Sale Promotion', icon: '🎉', style: 'Promotional sale graphic with pricing' },
    { id: 5, name: 'Unboxing', icon: '📦', style: 'Unboxing experience photography' },
    { id: 6, name: 'Comparison', icon: '🔍', style: 'Side-by-side product comparison' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Finance': [
    { id: 1, name: 'Data Dashboard', icon: '📊', style: 'Financial dashboard with charts and graphs' },
    { id: 2, name: 'Infographic Stats', icon: '📈', style: 'Financial statistics infographic design' },
    { id: 3, name: 'Professional Trust', icon: '🤝', style: 'Professional trustworthy business imagery' },
    { id: 4, name: 'Growth Visualization', icon: '📉', style: 'Growth and progress visualization' },
    { id: 5, name: 'Corporate Clean', icon: '💼', style: 'Clean corporate professional aesthetic' },
    { id: 6, name: 'Wealth Luxury', icon: '💰', style: 'Wealth and luxury lifestyle imagery' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Education': [
    { id: 1, name: 'Educational Infographic', icon: '📚', style: 'Educational infographic with diagrams' },
    { id: 2, name: 'Classroom Scene', icon: '👨‍🏫', style: 'Interactive classroom learning environment' },
    { id: 3, name: 'Study Guide', icon: '📝', style: 'Study guide with notes and highlights' },
    { id: 4, name: 'Achievement', icon: '🎓', style: 'Academic achievement and success focus' },
    { id: 5, name: 'Interactive Learning', icon: '💡', style: 'Interactive digital learning visualization' },
    { id: 6, name: 'Motivational', icon: '🌟', style: 'Inspirational motivational educational imagery' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Fashion & Beauty': [
    { id: 1, name: 'Fashion Editorial', icon: '📸', style: 'High-fashion editorial magazine style' },
    { id: 2, name: 'Beauty Close-up', icon: '💄', style: 'Beauty macro close-up detailed shot' },
    { id: 3, name: 'Lifestyle Fashion', icon: '✨', style: 'Lifestyle fashion in real-world context' },
    { id: 4, name: 'Before/After', icon: '🔄', style: 'Beauty transformation before and after' },
    { id: 5, name: 'Product Swatch', icon: '🎨', style: 'Product color swatches and textures' },
    { id: 6, name: 'Glamour Shot', icon: '💫', style: 'Glamorous high-end beauty photography' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Facilities Management': [
    { id: 1, name: 'Service Documentation', icon: '📋', style: 'Professional service documentation photo' },
    { id: 2, name: 'Before/After', icon: '🔄', style: 'Maintenance before and after comparison' },
    { id: 3, name: 'Safety Compliance', icon: '⚠️', style: 'Safety compliance and protocols visual' },
    { id: 4, name: 'Team in Action', icon: '👷', style: 'Service team actively working' },
    { id: 5, name: 'Quality Standards', icon: '✅', style: 'Quality standards and excellence focus' },
    { id: 6, name: 'Professional Clean', icon: '💼', style: 'Professional clean service aesthetic' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Travel & Hospitality': [
    { id: 1, name: 'Destination Hero', icon: '🗺️', style: 'Stunning destination hero photography' },
    { id: 2, name: 'Travel Guide', icon: '📖', style: 'Travel guide infographic with tips' },
    { id: 3, name: 'Luxury Experience', icon: '✨', style: 'Luxury hospitality experience imagery' },
    { id: 4, name: 'Cultural Immersion', icon: '🎭', style: 'Cultural authentic local experience' },
    { id: 5, name: 'Adventure Action', icon: '🏔️', style: 'Adventure travel action photography' },
    { id: 6, name: 'Relaxation', icon: '🌴', style: 'Peaceful relaxing vacation atmosphere' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Fitness & Wellness': [
    { id: 1, name: 'Action Shot', icon: '💪', style: 'Dynamic fitness action photography' },
    { id: 2, name: 'Transformation', icon: '🔄', style: 'Fitness transformation before and after' },
    { id: 3, name: 'Motivational Quote', icon: '⚡', style: 'Motivational fitness quote typography' },
    { id: 4, name: 'Workout Guide', icon: '📋', style: 'Exercise guide with step instructions' },
    { id: 5, name: 'Zen Wellness', icon: '🧘', style: 'Peaceful zen wellness meditation imagery' },
    { id: 6, name: 'Energy Burst', icon: '🔥', style: 'High-energy explosive workout imagery' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Legal Services': [
    { id: 1, name: 'Professional Authority', icon: '⚖️', style: 'Authoritative legal professional imagery with dark wood paneling, leather chairs, professional attire' },
    { id: 2, name: 'Document Focus', icon: '📄', style: 'Legal documents and paperwork focus with contracts, pens, stamps, organized folders on mahogany desk' },
    { id: 3, name: 'Infographic Legal', icon: '📊', style: 'Legal process infographic visualization with flowcharts, legal scales, gavel icons, professional graphics' },
    { id: 4, name: 'Consultation', icon: '🤝', style: 'Client consultation professional meeting in law office with leather chairs, bookshelves, warm lighting' },
    { id: 5, name: 'Courtroom', icon: '🏛️', style: 'Realistic courtroom interior with judge\'s bench, wooden jury box, witness stand, national flag, justice emblem, formal architecture, marble columns, mahogany wood paneling, gallery seating, professional court lighting' },
    { id: 6, name: 'Trust & Reliability', icon: '🛡️', style: 'Trustworthy reliable professional imagery with classic law office elements, certificates on walls, law library background' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'E-commerce': [
    { id: 1, name: 'Product Hero', icon: '🎯', style: 'Hero product shot with dramatic lighting' },
    { id: 2, name: 'Typography Product', icon: '✍️', style: 'Product with bold typography overlay' },
    { id: 3, name: 'White Background', icon: '⚪', style: 'Pure white background e-commerce shot' },
    { id: 4, name: '360° View', icon: '🔄', style: 'Multiple angle product showcase' },
    { id: 5, name: 'Lifestyle Use', icon: '✨', style: 'Product in lifestyle usage scenario' },
    { id: 6, name: 'Sale Banner', icon: '🎉', style: 'Promotional sale banner design' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Automotive': [
    { id: 1, name: 'Studio Showroom', icon: '🚗', style: 'Studio showroom professional photography' },
    { id: 2, name: 'Action Drive', icon: '🏁', style: 'Dynamic driving action shot with motion' },
    { id: 3, name: 'Scenic Location', icon: '🌄', style: 'Beautiful scenic destination backdrop' },
    { id: 4, name: 'Interior Detail', icon: '🪑', style: 'Interior cabin details and features' },
    { id: 5, name: 'Technical Specs', icon: '⚙️', style: 'Technical specifications visualization' },
    { id: 6, name: 'Luxury Lifestyle', icon: '✨', style: 'Luxury automotive lifestyle imagery' },
    { id: 7, name: 'Graphically Typographical', icon: '🎨', style: 'Artistic typography with graphic design elements, creative lettering and visual text art' }
  ],
  'Entertainment': [
    { id: 1, name: 'Cinematic', icon: '🎬', style: 'Cinematic movie poster aesthetic' },
    { id: 2, name: 'Event Poster', icon: '🎭', style: 'Event poster with bold typography' },
    { id: 3, name: 'Performance Action', icon: '🎤', style: 'Live performance action shot' },
    { id: 4, name: 'Neon Nightlife', icon: '🌃', style: 'Neon nightlife entertainment atmosphere' },
    { id: 5, name: 'Behind Scenes', icon: '🎥', style: 'Behind-the-scenes exclusive content' },
    { id: 6, name: 'Fan Excitement', icon: '🙌', style: 'Audience excitement and energy' }
  ],
  'Medical': [
    { id: 1, name: 'Medical Infographic', icon: '📊', style: 'Medical infographic with health information' },
    { id: 2, name: 'Clean Clinical', icon: '🏥', style: 'Clean clinical medical photography' },
    { id: 3, name: 'Patient Education', icon: '📚', style: 'Educational medical illustration style' },
    { id: 4, name: 'Health Stats', icon: '📈', style: 'Health statistics and data visualization' },
    { id: 5, name: 'Caring Touch', icon: '❤️', style: 'Warm caring compassionate medical imagery' },
    { id: 6, name: 'Safety Protocol', icon: '⚕️', style: 'Medical safety protocol visualization' }
  ]
};

// Industry-specific customization options
const INDUSTRY_CUSTOMIZATIONS = {
  'Food & Restaurant': {
    scale: [
      { id: 1, name: 'Single Plate', icon: '🍽️', style: 'Individual single serving' },
      { id: 2, name: 'Family Size', icon: '👨‍👩‍👧‍👦', style: 'Large family-size portion' },
      { id: 3, name: 'Buffet Display', icon: '🍱', style: 'Buffet-style arrangement' }
    ],
    angle: [
      { id: 1, name: 'Fine Dining', icon: '✨', style: 'Elegant fine dining presentation' },
      { id: 2, name: 'Street Food', icon: '🛒', style: 'Casual street food style' },
      { id: 3, name: 'Home Style', icon: '🏠', style: 'Cozy home-cooked style' },
      { id: 4, name: 'Modern Minimalist', icon: '⚪', style: 'Clean minimalist plating' }
    ],
    extras: [
      { id: 1, name: 'Fresh Herbs', icon: '🌿', style: 'with fresh herbs and microgreens' },
      { id: 2, name: 'With Cutlery', icon: '🍴', style: 'with elegant cutlery' },
      { id: 3, name: 'With Ingredients', icon: '🥗', style: 'surrounded by ingredients' },
      { id: 4, name: 'None', icon: '⭕', style: 'clean presentation' }
    ]
  },
  'Construction': {
    scale: [
      { id: 1, name: 'Close-Up', icon: '🔍', style: 'Detailed close-up shot' },
      { id: 2, name: 'Wide View', icon: '🌄', style: 'Wide-angle site overview' },
      { id: 3, name: 'Aerial View', icon: '🚁', style: 'Drone aerial perspective' }
    ],
    angle: [
      { id: 1, name: 'Action Shot', icon: '⚡', style: 'Dynamic action in progress' },
      { id: 2, name: 'Progress View', icon: '📈', style: 'Construction progress showcase' },
      { id: 3, name: 'Safety Focus', icon: '⚠️', style: 'Safety equipment highlighted' },
      { id: 4, name: 'Professional', icon: '💼', style: 'Professional corporate style' }
    ],
    extras: [
      { id: 1, name: 'Workers Present', icon: '👷', style: 'with construction workers visible' },
      { id: 2, name: 'Equipment Visible', icon: '🔧', style: 'with tools and equipment shown' },
      { id: 3, name: 'Signage Shown', icon: '🪧', style: 'with company signage displayed' },
      { id: 4, name: 'Clean Scene', icon: '⭕', style: 'clean isolated subject' }
    ]
  },
  'Technology': {
    scale: [
      { id: 1, name: 'Device Focus', icon: '📱', style: 'Single device spotlight' },
      { id: 2, name: 'Multi-Device', icon: '🖥️', style: 'Multiple devices showcase' },
      { id: 3, name: 'Environment', icon: '🏢', style: 'In real-world environment' }
    ],
    angle: [
      { id: 1, name: 'Futuristic', icon: '🚀', style: 'Futuristic high-tech aesthetic' },
      { id: 2, name: 'Corporate', icon: '💼', style: 'Corporate professional style' },
      { id: 3, name: 'Startup Vibe', icon: '💡', style: 'Startup innovative atmosphere' },
      { id: 4, name: 'Minimalist', icon: '⚪', style: 'Clean tech minimalism' }
    ],
    extras: [
      { id: 1, name: 'UI Visible', icon: '🖼️', style: 'with user interface displayed' },
      { id: 2, name: 'Code/Data', icon: '💻', style: 'with code or data visualization' },
      { id: 3, name: 'Hands Interacting', icon: '👆', style: 'with hands using device' },
      { id: 4, name: 'Clean Product', icon: '⭕', style: 'isolated product only' }
    ]
  },
  'Healthcare': {
    scale: [
      { id: 1, name: 'Close Detail', icon: '🔍', style: 'Detailed close-up medical view' },
      { id: 2, name: 'Full Scene', icon: '🏥', style: 'Complete medical environment' },
      { id: 3, name: 'Team View', icon: '👥', style: 'Medical team in action' }
    ],
    angle: [
      { id: 1, name: 'Professional', icon: '💼', style: 'Professional medical presentation' },
      { id: 2, name: 'Patient Care', icon: '❤️', style: 'Caring and compassionate focus' },
      { id: 3, name: 'Clinical', icon: '⚕️', style: 'Clinical sterile environment' },
      { id: 4, name: 'Modern', icon: '✨', style: 'Modern medical facility aesthetic' }
    ],
    extras: [
      { id: 1, name: 'Staff Visible', icon: '👨‍⚕️', style: 'with medical staff present' },
      { id: 2, name: 'Equipment Shown', icon: '🩺', style: 'with medical equipment visible' },
      { id: 3, name: 'Patient Focus', icon: '🙋', style: 'with patient care emphasis' },
      { id: 4, name: 'Clean Clinical', icon: '⭕', style: 'clean isolated medical scene' }
    ]
  },
  'Real Estate': {
    scale: [
      { id: 1, name: 'Interior', icon: '🛋️', style: 'Interior room detailed view' },
      { id: 2, name: 'Exterior', icon: '🏠', style: 'Exterior building facade' },
      { id: 3, name: 'Panoramic', icon: '🌄', style: 'Wide panoramic property view' }
    ],
    angle: [
      { id: 1, name: 'Luxury', icon: '✨', style: 'Luxury high-end presentation' },
      { id: 2, name: 'Cozy', icon: '🏡', style: 'Warm cozy comfortable atmosphere' },
      { id: 3, name: 'Modern', icon: '🏢', style: 'Modern contemporary design' },
      { id: 4, name: 'Natural Light', icon: '☀️', style: 'Bright natural lighting' }
    ],
    extras: [
      { id: 1, name: 'Furnished', icon: '🛋️', style: 'with furniture and decor' },
      { id: 2, name: 'Empty Space', icon: '📐', style: 'empty showcasing space' },
      { id: 3, name: 'Outdoor View', icon: '🌳', style: 'with outdoor surroundings visible' },
      { id: 4, name: 'Clean Minimal', icon: '⭕', style: 'minimal clean presentation' }
    ]
  },
  // Default customization for remaining industries
  'Retail': {
    scale: [
      { id: 1, name: 'Product Focus', icon: '🎯', style: 'Single product detailed shot' },
      { id: 2, name: 'Collection', icon: '📦', style: 'Product collection display' },
      { id: 3, name: 'Store View', icon: '🏪', style: 'Full store environment view' }
    ],
    angle: [
      { id: 1, name: 'Commercial', icon: '💼', style: 'Professional commercial style' },
      { id: 2, name: 'Lifestyle', icon: '✨', style: 'Lifestyle and aspirational' },
      { id: 3, name: 'Promotional', icon: '🎉', style: 'Sale and promotional focus' },
      { id: 4, name: 'Minimalist', icon: '⚪', style: 'Clean minimal aesthetic' }
    ],
    extras: [
      { id: 1, name: 'Pricing Visible', icon: '💰', style: 'with pricing and tags visible' },
      { id: 2, name: 'Lifestyle Context', icon: '👤', style: 'with people using products' },
      { id: 3, name: 'Brand Elements', icon: '🏷️', style: 'with brand packaging shown' },
      { id: 4, name: 'Clean Product', icon: '⭕', style: 'isolated product shot' }
    ]
  },
  'Finance': {
    scale: [
      { id: 1, name: 'Close-Up', icon: '🔍', style: 'Detailed financial focus' },
      { id: 2, name: 'Office Scene', icon: '🏢', style: 'Professional office environment' },
      { id: 3, name: 'Data View', icon: '📊', style: 'Charts and data visualization' }
    ],
    angle: [
      { id: 1, name: 'Professional', icon: '💼', style: 'Corporate professional aesthetic' },
      { id: 2, name: 'Trustworthy', icon: '🤝', style: 'Trustworthy and reliable feel' },
      { id: 3, name: 'Modern Digital', icon: '💻', style: 'Modern fintech digital' },
      { id: 4, name: 'Elegant', icon: '✨', style: 'Sophisticated elegant style' }
    ],
    extras: [
      { id: 1, name: 'Charts Visible', icon: '📈', style: 'with financial charts and graphs' },
      { id: 2, name: 'People Present', icon: '👔', style: 'with professionals in scene' },
      { id: 3, name: 'Technology', icon: '💻', style: 'with digital technology shown' },
      { id: 4, name: 'Clean Corporate', icon: '⭕', style: 'minimal corporate style' }
    ]
  },
  'Education': {
    scale: [
      { id: 1, name: 'Classroom', icon: '👨‍🏫', style: 'Full classroom environment' },
      { id: 2, name: 'Student Focus', icon: '🎓', style: 'Individual student learning' },
      { id: 3, name: 'Campus Wide', icon: '🏫', style: 'Wide campus environment view' }
    ],
    angle: [
      { id: 1, name: 'Inspiring', icon: '💡', style: 'Inspiring and motivational' },
      { id: 2, name: 'Interactive', icon: '🤝', style: 'Interactive and engaging' },
      { id: 3, name: 'Traditional', icon: '📚', style: 'Traditional academic style' },
      { id: 4, name: 'Modern Tech', icon: '💻', style: 'Modern tech-enabled learning' }
    ],
    extras: [
      { id: 1, name: 'Students Visible', icon: '👨‍🎓', style: 'with students in scene' },
      { id: 2, name: 'Teacher Present', icon: '👨‍🏫', style: 'with instructor teaching' },
      { id: 3, name: 'Technology Shown', icon: '💻', style: 'with educational technology' },
      { id: 4, name: 'Clean Academic', icon: '⭕', style: 'clean educational setting' }
    ]
  },
  'Fashion & Beauty': {
    scale: [
      { id: 1, name: 'Model Shot', icon: '💃', style: 'Model wearing or using product' },
      { id: 2, name: 'Product Detail', icon: '👗', style: 'Detailed product close-up' },
      { id: 3, name: 'Collection', icon: '✨', style: 'Full collection showcase' }
    ],
    angle: [
      { id: 1, name: 'High Fashion', icon: '👠', style: 'High-end fashion editorial' },
      { id: 2, name: 'Casual Trendy', icon: '👕', style: 'Casual trendy streetwear' },
      { id: 3, name: 'Glamorous', icon: '💄', style: 'Glamorous beauty focus' },
      { id: 4, name: 'Natural', icon: '🌿', style: 'Natural organic aesthetic' }
    ],
    extras: [
      { id: 1, name: 'Model Wearing', icon: '💃', style: 'with model showcasing product' },
      { id: 2, name: 'Makeup Applied', icon: '💄', style: 'with makeup application shown' },
      { id: 3, name: 'Accessories', icon: '💍', style: 'with complementary accessories' },
      { id: 4, name: 'Clean Product', icon: '⭕', style: 'isolated product presentation' }
    ]
  },
  'Facilities Management': {
    scale: [
      { id: 1, name: 'Detail Work', icon: '🔧', style: 'Close-up maintenance work' },
      { id: 2, name: 'Facility View', icon: '🏢', style: 'Full facility environment' },
      { id: 3, name: 'Team Action', icon: '👷', style: 'Team working together' }
    ],
    angle: [
      { id: 1, name: 'Professional', icon: '💼', style: 'Professional service presentation' },
      { id: 2, name: 'Action Focus', icon: '⚡', style: 'Active work in progress' },
      { id: 3, name: 'Quality Service', icon: '✨', style: 'Quality and excellence focus' },
      { id: 4, name: 'Safety First', icon: '⚠️', style: 'Safety and compliance focus' }
    ],
    extras: [
      { id: 1, name: 'Staff Visible', icon: '👷', style: 'with maintenance staff shown' },
      { id: 2, name: 'Equipment Shown', icon: '🔧', style: 'with tools and equipment' },
      { id: 3, name: 'Before/After', icon: '🔄', style: 'showing improvement results' },
      { id: 4, name: 'Clean Setup', icon: '⭕', style: 'clean professional setting' }
    ]
  },
  'Travel & Hospitality': {
    scale: [
      { id: 1, name: 'Destination', icon: '🗺️', style: 'Beautiful destination view' },
      { id: 2, name: 'Interior Space', icon: '🛏️', style: 'Hotel or venue interior' },
      { id: 3, name: 'Experience', icon: '✈️', style: 'Guest experience moment' }
    ],
    angle: [
      { id: 1, name: 'Luxurious', icon: '✨', style: 'Luxury premium experience' },
      { id: 2, name: 'Adventurous', icon: '🏔️', style: 'Adventure and exploration' },
      { id: 3, name: 'Relaxing', icon: '🌴', style: 'Peaceful relaxing atmosphere' },
      { id: 4, name: 'Cultural', icon: '🎭', style: 'Cultural authentic experience' }
    ],
    extras: [
      { id: 1, name: 'Guests Visible', icon: '👥', style: 'with happy guests enjoying' },
      { id: 2, name: 'Amenities Shown', icon: '🏊', style: 'with amenities highlighted' },
      { id: 3, name: 'Local Culture', icon: '🏛️', style: 'with cultural elements' },
      { id: 4, name: 'Clean Scenic', icon: '⭕', style: 'pristine scenic view' }
    ]
  },
  'Fitness & Wellness': {
    scale: [
      { id: 1, name: 'Action Shot', icon: '🏃', style: 'Person exercising or active' },
      { id: 2, name: 'Facility View', icon: '🏋️', style: 'Gym or wellness facility' },
      { id: 3, name: 'Close Detail', icon: '💪', style: 'Detailed fitness focus' }
    ],
    angle: [
      { id: 1, name: 'Motivational', icon: '⚡', style: 'Energetic and motivational' },
      { id: 2, name: 'Serene', icon: '🧘', style: 'Calm peaceful wellness' },
      { id: 3, name: 'Athletic', icon: '🏅', style: 'Athletic performance focused' },
      { id: 4, name: 'Lifestyle', icon: '💚', style: 'Healthy lifestyle aesthetic' }
    ],
    extras: [
      { id: 1, name: 'People Active', icon: '🏃', style: 'with people exercising' },
      { id: 2, name: 'Equipment Visible', icon: '🏋️', style: 'with fitness equipment shown' },
      { id: 3, name: 'Results Focus', icon: '💪', style: 'showing transformation results' },
      { id: 4, name: 'Clean Health', icon: '⭕', style: 'clean healthy presentation' }
    ]
  },
  'Legal Services': {
    scale: [
      { id: 1, name: 'Office Setting', icon: '🏛️', style: 'Professional law office with mahogany furniture, law books, certificates' },
      { id: 2, name: 'Consultation', icon: '🤝', style: 'Client consultation scene with conference table, professional setting' },
      { id: 3, name: 'Courtroom', icon: '⚖️', style: 'Full courtroom interior with judge\'s elevated bench, jury box on left, witness stand, counsel tables, gallery pews, court reporter desk, national flags, justice emblem, wood paneling, formal columns' }
    ],
    angle: [
      { id: 1, name: 'Professional', icon: '💼', style: 'Highly professional corporate' },
      { id: 2, name: 'Trustworthy', icon: '🛡️', style: 'Trustworthy and reliable' },
      { id: 3, name: 'Authoritative', icon: '⚖️', style: 'Authoritative and confident' },
      { id: 4, name: 'Approachable', icon: '🤝', style: 'Friendly approachable style' }
    ],
    extras: [
      { id: 1, name: 'Lawyers Visible', icon: '👔', style: 'with legal professionals shown' },
      { id: 2, name: 'Documents Shown', icon: '📄', style: 'with legal documents visible' },
      { id: 3, name: 'Books & Resources', icon: '📚', style: 'with law books and resources' },
      { id: 4, name: 'Clean Professional', icon: '⭕', style: 'minimal professional setting' }
    ]
  },
  'E-commerce': {
    scale: [
      { id: 1, name: 'Product Focus', icon: '📦', style: 'Single product hero shot' },
      { id: 2, name: 'Lifestyle Use', icon: '🛍️', style: 'Product in lifestyle context' },
      { id: 3, name: 'Unboxing', icon: '📦', style: 'Unboxing and packaging view' }
    ],
    angle: [
      { id: 1, name: 'E-commerce', icon: '🛒', style: 'Clean e-commerce product shot' },
      { id: 2, name: 'Lifestyle', icon: '✨', style: 'Aspirational lifestyle focus' },
      { id: 3, name: 'Comparison', icon: '🔍', style: 'Product comparison angles' },
      { id: 4, name: 'Promotional', icon: '🎁', style: 'Promotional sale style' }
    ],
    extras: [
      { id: 1, name: 'Multiple Angles', icon: '🔄', style: 'with various product angles' },
      { id: 2, name: 'Size Reference', icon: '📏', style: 'with size comparison shown' },
      { id: 3, name: 'Packaging', icon: '📦', style: 'with branded packaging visible' },
      { id: 4, name: 'White Background', icon: '⭕', style: 'pure white background' }
    ]
  },
  'Automotive': {
    scale: [
      { id: 1, name: 'Full Vehicle', icon: '🚗', style: 'Complete vehicle showcase' },
      { id: 2, name: 'Interior Detail', icon: '🪑', style: 'Interior cabin details' },
      { id: 3, name: 'Feature Close-up', icon: '🔍', style: 'Specific feature highlight' }
    ],
    angle: [
      { id: 1, name: 'Luxury', icon: '✨', style: 'Luxury premium presentation' },
      { id: 2, name: 'Performance', icon: '🏁', style: 'Performance and speed focus' },
      { id: 3, name: 'Family', icon: '👨‍👩‍👧', style: 'Family-friendly practical' },
      { id: 4, name: 'Rugged', icon: '🏔️', style: 'Adventurous rugged style' }
    ],
    extras: [
      { id: 1, name: 'Scenic Location', icon: '🌄', style: 'with beautiful scenic background' },
      { id: 2, name: 'People Present', icon: '👤', style: 'with people using vehicle' },
      { id: 3, name: 'Service Focus', icon: '🔧', style: 'with service and maintenance' },
      { id: 4, name: 'Clean Studio', icon: '⭕', style: 'studio clean presentation' }
    ]
  },
  'Digital Marketing': {
    scale: [
      { id: 1, name: 'Social Post', icon: '📱', style: 'Social media post format' },
      { id: 2, name: 'Banner Ad', icon: '🖼️', style: 'Wide banner advertisement' },
      { id: 3, name: 'Story Format', icon: '📲', style: 'Vertical story dimensions' }
    ],
    angle: [
      { id: 1, name: 'Bold & Vibrant', icon: '🎨', style: 'Bold colorful eye-catching' },
      { id: 2, name: 'Professional', icon: '💼', style: 'Corporate professional clean' },
      { id: 3, name: 'Trendy Modern', icon: '✨', style: 'Modern trendy aesthetic' },
      { id: 4, name: 'Minimalist', icon: '⚪', style: 'Clean minimal design' }
    ],
    extras: [
      { id: 1, name: 'Text Overlay', icon: '💬', style: 'with promotional text overlay' },
      { id: 2, name: 'Call-to-Action', icon: '👆', style: 'with CTA button visible' },
      { id: 3, name: 'Brand Elements', icon: '🏷️', style: 'with branding elements shown' },
      { id: 4, name: 'Clean Visual', icon: '⭕', style: 'pure visual no text' }
    ]
  },
  'Medical': {
    scale: [
      { id: 1, name: 'Close Detail', icon: '🔍', style: 'Detailed close-up medical view' },
      { id: 2, name: 'Full Scene', icon: '🏥', style: 'Complete medical environment' },
      { id: 3, name: 'Team View', icon: '👥', style: 'Medical team in action' }
    ],
    angle: [
      { id: 1, name: 'Professional', icon: '💼', style: 'Professional medical presentation' },
      { id: 2, name: 'Patient Care', icon: '❤️', style: 'Caring and compassionate focus' },
      { id: 3, name: 'Clinical', icon: '⚕️', style: 'Clinical sterile environment' },
      { id: 4, name: 'Modern', icon: '✨', style: 'Modern medical facility aesthetic' }
    ],
    extras: [
      { id: 1, name: 'Staff Visible', icon: '👨‍⚕️', style: 'with medical staff present' },
      { id: 2, name: 'Equipment Shown', icon: '🩺', style: 'with medical equipment visible' },
      { id: 3, name: 'Patient Focus', icon: '🙋', style: 'with patient care emphasis' },
      { id: 4, name: 'Clean Clinical', icon: '⭕', style: 'clean isolated medical scene' }
    ]
  },
  'Entertainment': {
    scale: [
      { id: 1, name: 'Stage View', icon: '🎭', style: 'Full stage or venue view' },
      { id: 2, name: 'Close Performance', icon: '🎤', style: 'Close-up performance shot' },
      { id: 3, name: 'Audience View', icon: '👥', style: 'Audience experience perspective' }
    ],
    angle: [
      { id: 1, name: 'Dramatic', icon: '🎬', style: 'Dramatic cinematic style' },
      { id: 2, name: 'Energetic', icon: '⚡', style: 'High-energy exciting' },
      { id: 3, name: 'Intimate', icon: '🎵', style: 'Intimate close personal' },
      { id: 4, name: 'Epic', icon: '🌟', style: 'Epic large-scale production' }
    ],
    extras: [
      { id: 1, name: 'Performers', icon: '🎭', style: 'with performers in action' },
      { id: 2, name: 'Crowd Energy', icon: '🙌', style: 'with excited audience' },
      { id: 3, name: 'Lighting Effects', icon: '💡', style: 'with stage lighting and effects' },
      { id: 4, name: 'Clean Artistic', icon: '⭕', style: 'artistic clean presentation' }
    ]
  }
};

function AIMagicSection({ user }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Get effective industry FIRST before using it
  const effectiveIndustry = user.current_industry || user.industry;
  
  // Get industry-specific categories or default to Food & Restaurant
  const industryConfig = INDUSTRY_CONTENT_CATEGORIES[effectiveIndustry] || INDUSTRY_CONTENT_CATEGORIES['Food & Restaurant'];
  const contentCategories = industryConfig.categories;
  const categoryTitle = industryConfig.title;
  
  // Get industry customization options
  const industryCustomization = INDUSTRY_CUSTOMIZATIONS[effectiveIndustry] || INDUSTRY_CUSTOMIZATIONS['Food & Restaurant'];
  
  // Get industry-specific image styles
  const industryImageStyles = INDUSTRY_IMAGE_STYLES[effectiveIndustry] || INDUSTRY_IMAGE_STYLES['Food & Restaurant'];
  
  // Main selections
  const [selectedCuisine, setSelectedCuisine] = useState(null);
  const [selectedFoodItems, setSelectedFoodItems] = useState([]); // CHANGED: Multiple selection
  const [selectedImageType, setSelectedImageType] = useState(null);
  const [selectedDesignStyle, setSelectedDesignStyle] = useState(null); // NEW: Step 3
  
  // Additional features - Dynamic based on industry
  const [selectedScale, setSelectedScale] = useState(industryCustomization.scale[0]); // Default: first option
  const [selectedAngle, setSelectedAngle] = useState(industryCustomization.angle[0]); // Default: first option
  const [selectedExtras, setSelectedExtras] = useState([industryCustomization.extras[0]]); // Multiple selection
  
  // NEW: Manual prompt and brand toggle
  const [manualPrompt, setManualPrompt] = useState('');
  const [includeBrand, setIncludeBrand] = useState(true); // Default: include brand
  const [imageSize, setImageSize] = useState('square'); // NEW: Image size/platform selector
  const [showCustomization, setShowCustomization] = useState(false); // Toggle for Step 4
  const [promptEdited, setPromptEdited] = useState(false); // Track if user edited the prompt
  
  // Collapse states for Digital Marketing steps
  const [collapseStep1, setCollapseStep1] = useState(false);
  const [collapseStep2, setCollapseStep2] = useState(false);
  const [collapseStep3, setCollapseStep3] = useState(false);
  const [collapseStep4, setCollapseStep4] = useState(false);
  const [collapseStep5, setCollapseStep5] = useState(false);
  const [collapseStep6, setCollapseStep6] = useState(false);
  
  // Brand Templates
  const [templates, setTemplates] = useState([]);
  const [showSaveTemplateModal, setShowSaveTemplateModal] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [templateIcon, setTemplateIcon] = useState('📋');
  const [templateDescription, setTemplateDescription] = useState('');
  
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);


  // Load templates on mount
  useEffect(() => {
    if (effectiveIndustry === 'Digital Marketing') {
      fetchTemplates();
    }
  }, [effectiveIndustry]);

  const fetchTemplates = async () => {
    try {
      const response = await axios.get(`${API}/users/${user.id}/templates`);
      setTemplates(response.data.templates || []);
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const loadTemplate = (template) => {
    // Load campaign type
    setSelectedCuisine(contentCategories.campaign);
    setSelectedFoodItems([template.campaign_type]);
    
    // Load content type
    setSelectedImageType(template.content_type);
    
    // Load design style
    setSelectedDesignStyle(template.design_style);
    
    // Load customization if enabled
    if (template.customization_enabled && template.customization) {
      setShowCustomization(true);
      setSelectedScale(template.customization.scale);
      setSelectedAngle(template.customization.angle);
      setSelectedExtras(template.customization.extras);
    } else {
      setShowCustomization(false);
    }
    
    // Load manual prompt (Step 5)
    if (template.manual_prompt) {
      setManualPrompt(template.manual_prompt);
    } else {
      setManualPrompt('');
    }
    
    // Load brand toggle (Step 6)
    if (template.include_brand !== undefined) {
      setIncludeBrand(template.include_brand);
    }
    
    alert(`✅ Template "${template.name}" loaded!\n\n` +
          `Campaign: ${template.campaign_type.name}\n` +
          `Content: ${template.content_type.name}\n` +
          `Style: ${template.design_style.name}` +
          (template.manual_prompt ? `\n\nCustom Instructions: "${template.manual_prompt.substring(0, 50)}..."` : ''));
  };

  const saveTemplate = async () => {
    if (!templateName.trim()) {
      alert('Please enter a template name');
      return;
    }
    
    if (selectedFoodItems.length === 0 || !selectedImageType || !selectedDesignStyle) {
      alert('Please select all 3 steps before saving a template');
      return;
    }
    
    try {
      const templateData = {
        user_id: user.id,
        name: templateName.trim(),
        icon: templateIcon,
        description: templateDescription.trim(),
        campaign_type: selectedFoodItems[0],
        content_type: selectedImageType,
        design_style: selectedDesignStyle,
        customization_enabled: showCustomization,
        customization: showCustomization ? {
          scale: selectedScale,
          angle: selectedAngle,
          extras: selectedExtras
        } : null,
        manual_prompt: manualPrompt || '',  // Save manual prompt (Step 5)
        include_brand: includeBrand  // Save brand toggle (Step 6)
      };
      
      await axios.post(`${API}/users/${user.id}/templates`, templateData);
      
      // Reload templates
      await fetchTemplates();
      
      // Reset modal
      setShowSaveTemplateModal(false);
      setTemplateName('');
      setTemplateIcon('📋');
      setTemplateDescription('');
      
      alert('✅ Template saved successfully!');
    } catch (error) {
      console.error('Error saving template:', error);
      alert('❌ Failed to save template');
    }
  };

  const deleteTemplate = async (templateId) => {
    if (!window.confirm('Are you sure you want to delete this template?')) {
      return;
    }
    
    try {
      await axios.delete(`${API}/users/${user.id}/templates/${templateId}`);
      await fetchTemplates();
      alert('✅ Template deleted successfully');
    } catch (error) {
      console.error('Error deleting template:', error);
      alert('❌ Failed to delete template');
    }
  };

  // Auto-build preview prompt from selections (updates Step 5)
  useEffect(() => {
    if (promptEdited) return; // Don't overwrite if user manually edited
    
    let prompt = '';
    
    if (effectiveIndustry === 'Digital Marketing') {
      if (selectedFoodItems.length > 0 && selectedImageType) {
        const campaignType = selectedFoodItems[0];
        const contentType = selectedImageType;
        prompt = `Create a ${contentType.name.toLowerCase()} for a ${campaignType.name.toLowerCase()} campaign. Theme: ${campaignType.prompt}. Format: ${contentType.prompt}.`;
        if (selectedDesignStyle) {
          prompt += ` Design style: ${selectedDesignStyle.prompt}.`;
        }
        if (showCustomization) {
          const extrasDesc = selectedExtras.map(e => e.style).join(', ');
          prompt += ` ${selectedScale.style}. ${selectedAngle.style}. ${extrasDesc}.`;
        }
        prompt += ` Professional marketing design, eye-catching composition, modern and polished.`;
      }
    } else {
      if (selectedFoodItems.length > 0) {
        const itemDescriptions = selectedFoodItems.map(item => item.prompt).join(', ');
        prompt = `${itemDescriptions}.`;
        if (selectedImageType) {
          prompt += ` ${selectedImageType.style}.`;
        }
        if (showCustomization) {
          const extrasDesc = selectedExtras.map(e => e.style).join(', ');
          prompt += ` ${selectedScale.style}. ${selectedAngle.style}. ${extrasDesc}.`;
        }
        prompt += ` Professional high-quality photography, perfect composition, vibrant colors, sharp details.`;
      }
    }
    
    if (prompt) {
      setManualPrompt(prompt);
    }
  }, [selectedFoodItems, selectedImageType, selectedDesignStyle, showCustomization, selectedScale, selectedAngle, selectedExtras, effectiveIndustry, promptEdited]);

  const generateContentImage = async () => {
    // Validation for Digital Marketing
    if (effectiveIndustry === 'Digital Marketing') {
      if (selectedFoodItems.length === 0) {
        alert('Please select a Campaign Type (Step 1)');
        return;
      }
      if (!selectedImageType) {
        alert('Please select a Content Type (Step 2)');
        return;
      }
      if (!selectedDesignStyle) {
        alert('Please select a Design Style (Step 3)');
        return;
      }
    } else {
      // Validation for other industries
      if (selectedFoodItems.length === 0 || !selectedImageType) {
        alert('Please select at least one item and image style');
        return;
      }
    }

    try {
      setLoading(true);
      setError('');
      
      console.log('Generating AI Magic image with all options:', {
        industry: effectiveIndustry,
        items: selectedFoodItems.map(f => f.name),
        imageType: selectedImageType.name,
        scale: selectedScale.name,
        angle: selectedAngle.name,
        extras: selectedExtras.map(e => e.name),
        manualPrompt,
        includeBrand
      });
      
      // Build comprehensive image prompt combining all selections
      let imagePrompt = '';
      
      // Use the editable prompt from Step 5 (auto-generated or user-edited)
      if (manualPrompt.trim()) {
        imagePrompt = manualPrompt.trim();
      } else if (effectiveIndustry === 'Digital Marketing') {
        // Fallback: Build from selections if prompt is empty
        const campaignType = selectedFoodItems[0];
        const contentType = selectedImageType;
        const designStyle = selectedDesignStyle;
        
        imagePrompt = `Create a ${contentType.name.toLowerCase()} for a ${campaignType.name.toLowerCase()} campaign. `;
        imagePrompt += `Theme: ${campaignType.prompt}. `;
        imagePrompt += `Format: ${contentType.prompt}. `;
        if (designStyle) {
          imagePrompt += `Design style: ${designStyle.prompt}. `;
        }
        imagePrompt += `Professional marketing design, eye-catching composition, modern and polished.`;
      } else {
        // Fallback: Build from selections if prompt is empty
        const itemDescriptions = selectedFoodItems.map(item => item.prompt).join(', ');
        imagePrompt = `${itemDescriptions}. ${selectedImageType.style}. Professional high-quality photography, perfect composition, vibrant colors, sharp details.`;
      }
      
      // Always add brand colors if set (not part of the editable prompt)
      if (effectiveIndustry === 'Digital Marketing' && user.follow_brand_colors && user.brand_primary_color) {
          const colorNames = {
            '#171717': 'dark charcoal',
            '#0A0F1C': 'deep space blue',
            '#1E3A8A': 'electric blue',
            '#EF4444': 'bold red',
            '#06B6D4': 'cyan',
            '#10B981': 'emerald green',
            '#6366F1': 'indigo',
            '#0A0A0A': 'pure black',
            '#1F2937': 'charcoal gray',
            '#3B82F6': 'bright blue'
          };
          
          const primaryColorName = colorNames[user.brand_primary_color] || 'brand primary';
          const accentColorName = colorNames[user.brand_accent_color_1] || 'brand accent';
          
          imagePrompt += ` Use brand color palette with ${primaryColorName} as primary color and ${accentColorName} as accent color prominently.`;
          
          if (user.brand_font_style) {
            imagePrompt += ` Typography: ${user.brand_font_style} font style.`;
          }
      }
      
      // Add brand integration based on user's brand settings and checkbox
      if (includeBrand && user.brand_name) {
        const brandMode = user.brand_scene_mode || 'text_only';
        if (brandMode === 'text_only' || brandMode === 'text_and_logo') {
          imagePrompt += ` IMPORTANT: Include the brand name "${user.brand_name}" prominently displayed in the scene as clear, readable text on signage or displays.`;
        }
        if ((brandMode === 'logo_only' || brandMode === 'text_and_logo') && user.brand_scene_logo) {
          imagePrompt += ` Include brand logo naturally integrated into the scene.`;
        }
      }
      
      console.log('Sending image request with prompt:', imagePrompt);
      console.log('Request payload:', {
        user_id: user.id,
        industry: effectiveIndustry,
        prompt: imagePrompt
      });
      
      const response = await axios.post(`${API}/generate/image`, {
        user_id: user.id,
        industry: effectiveIndustry,
        prompt: imagePrompt,
        include_brand: includeBrand,
        image_size: imageSize
      });

      console.log('AI Magic image generated successfully:', response.data);

      // Store image for preview with all details
      let captionDetails = '';
      
      if (effectiveIndustry === 'Digital Marketing') {
        // For Digital Marketing: Show Campaign Type, Content Type, Design Style
        captionDetails = `Campaign: ${selectedFoodItems[0].name}\nContent: ${selectedImageType.name}`;
        if (selectedDesignStyle) {
          captionDetails += `\nDesign: ${selectedDesignStyle.name}`;
        }
        if (showCustomization) {
          const extrasNames = selectedExtras.map(e => e.name).join(', ');
          captionDetails += `\n\nCustomization:\nScale: ${selectedScale.name}\nAngle: ${selectedAngle.name}\nExtras: ${extrasNames}`;
        }
      } else {
        // For other industries: Use original format
        const itemNames = selectedFoodItems.map(f => f.name).join(', ');
        captionDetails = `${selectedCuisine.name} - ${itemNames}\n\nStyle: ${selectedImageType.name}`;
        if (showCustomization) {
          const extrasNames = selectedExtras.map(e => e.name).join(', ');
          captionDetails += `\nScale: ${selectedScale.name}\nAngle: ${selectedAngle.name}\nExtras: ${extrasNames}`;
        }
      }
      
      captionDetails += `${manualPrompt ? `\n\nCustom: ${manualPrompt}` : ''}${includeBrand ? '\n\n✓ Brand included' : ''}`;
      
      setPreviewData({
        image: `data:image/png;base64,${response.data.image_base64}`,
        caption: captionDetails,
        imageBase64: response.data.image_base64,
        // Store selections for template saving
        savedSelections: {
          campaignType: selectedFoodItems[0],
          contentType: selectedImageType,
          designStyle: selectedDesignStyle,
          customizationEnabled: showCustomization,
          customization: showCustomization ? {
            scale: selectedScale,
            angle: selectedAngle,
            extras: selectedExtras
          } : null,
          manualPrompt: manualPrompt,  // Step 5
          includeBrand: includeBrand    // Step 6
        }
      });
      setShowPreview(true);

      // Don't reset selections immediately - wait until preview closes
      // setSelectedFoodItems([]);

    } catch (err) {
      console.error('AI Magic image generation error:', err);
      console.error('Error details:', {
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        message: err.message
      });
      
      const errorMessage = err.response?.data?.detail || err.message || 'Unknown error';
      setError(errorMessage);
      alert('❌ Failed to generate image: ' + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const [aiCaption, setAiCaption] = useState('');
  const [generatingCaption, setGeneratingCaption] = useState(false);

  const generateAICaption = async () => {
    try {
      setGeneratingCaption(true);
      
      // Build context for AI caption generation
      const itemNames = selectedFoodItems.map(f => f.name).join(', ');
      const context = `Industry: ${effectiveIndustry}, Content: ${itemNames}, Style: ${selectedImageType.name}`;
      
      const response = await axios.post(`${API}/generate/content`, {
        user_id: user.id,
        platform: 'General',
        industry: effectiveIndustry,
        tone: 'professional',
        context: `Generate an engaging social media caption for this AI-generated image. ${context}. Make it catchy, relevant, and include relevant hashtags.`
      });

      const generatedCaption = response.data.content || response.data.caption || '';
      setAiCaption(generatedCaption);
      alert('✅ AI Caption generated successfully!');

    } catch (err) {
      console.error('AI caption generation error:', err);
      alert('❌ Failed to generate caption: ' + (err.response?.data?.detail || err.message));
    } finally {
      setGeneratingCaption(false);
    }
  };

  const savePostToGallery = async () => {
    try {
      setLoading(true);
      
      const postResponse = await axios.post(`${API}/posts`, {
        user_id: user.id,
        platform: 'General',
        industry: effectiveIndustry
      });

      await axios.put(`${API}/posts/${postResponse.data.id}`, {
        content: aiCaption || previewData.caption,
        image_base64: previewData.imageBase64
      });

      alert('✅ Post saved successfully! Check Posts tab.');
      setShowPreview(false);
      setPreviewData(null);
      setAiCaption('');

    } catch (err) {
      console.error('Save post error:', err);
      alert('❌ Failed to save post: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="space-y-6">
        
        {/* === DIGITAL MARKETING - NEW SIMPLE 3-STEP SYSTEM === */}
        {effectiveIndustry === 'Digital Marketing' ? (
          <>
            {/* BRAND TEMPLATES SECTION */}
            <div className="theme-card border rounded-xl p-4 mb-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold accent-text flex items-center">
                  <span className="mr-2">📋</span>
                  My Brand Templates
                </h3>
                <button
                  onClick={() => setShowSaveTemplateModal(true)}
                  disabled={!selectedFoodItems.length || !selectedImageType || !selectedDesignStyle}
                  className="px-4 py-2 text-sm rounded-lg transition disabled:opacity-40 disabled:cursor-not-allowed accent-gradient text-white"
                >
                  + Save Current as Template
                </button>
              </div>
              
              {templates.length === 0 ? (
                <p className="text-center py-4" style={{ color: 'var(--text-muted)' }}>
                  No templates saved yet. Select all 3 steps and click "Save Current as Template" to create your first template!
                </p>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                  {templates.map((template) => (
                    <div
                      key={template.id}
                      className="theme-card-nested border rounded-lg p-4 transition cursor-pointer hover:scale-105"
                      style={{ borderColor: 'var(--border-color)' }}
                    >
                      <div className="flex items-start justify-between mb-2">
                        <span className="text-3xl">{template.icon}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteTemplate(template.id);
                          }}
                          className="text-red-400 hover:text-red-300 text-sm"
                          title="Delete template"
                        >
                          ✕
                        </button>
                      </div>
                      <h4 className="font-semibold mb-1 accent-text">{template.name}</h4>
                      {template.description && (
                        <p className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>{template.description}</p>
                      )}
                      <div className="text-xs mb-3" style={{ color: 'var(--text-secondary)' }}>
                        <div>🎯 {template.campaign_type.name}</div>
                        <div>📝 {template.content_type.name}</div>
                        <div>🎨 {template.design_style.name}</div>
                        {template.manual_prompt && (
                          <div className="mt-1 flex items-center gap-1">
                            <span>✍️</span>
                            <span className="italic">Has custom instructions</span>
                          </div>
                        )}
                      </div>
                      <button
                        onClick={() => loadTemplate(template)}
                        className="w-full py-2 px-3 text-xs rounded-lg accent-gradient text-white transition hover:opacity-90"
                      >
                        Load Template
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Save Template Modal */}
            {showSaveTemplateModal && (
              <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50" onClick={() => setShowSaveTemplateModal(false)}>
                <div className="theme-card border rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} style={{ borderColor: 'var(--border-color)' }}>
                  <h3 className="text-2xl font-bold mb-4 accent-text">Save Brand Template</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                        Template Name *
                      </label>
                      <input
                        type="text"
                        value={templateName}
                        onChange={(e) => setTemplateName(e.target.value)}
                        placeholder="e.g., Social Posts, Product Launch"
                        className="theme-input w-full px-4 py-2 rounded-lg border"
                        style={{ borderColor: 'var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-primary)' }}
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                        Icon
                      </label>
                      <div className="grid grid-cols-8 gap-2">
                        {['📱', '🚀', '📊', '⭐', '🎨', '💼', '📚', '🎁', '🎯', '💡', '📋', '✨', '🔥', '💪', '🎉', '📝'].map((emoji) => (
                          <button
                            key={emoji}
                            onClick={() => setTemplateIcon(emoji)}
                            className={`text-2xl p-2 rounded-lg transition ${
                              templateIcon === emoji ? 'accent-gradient' : 'theme-card-nested'
                            }`}
                          >
                            {emoji}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                        Description (Optional)
                      </label>
                      <textarea
                        value={templateDescription}
                        onChange={(e) => setTemplateDescription(e.target.value)}
                        placeholder="Brief description of this template..."
                        className="theme-input w-full px-4 py-2 rounded-lg border resize-none"
                        rows="2"
                        style={{ borderColor: 'var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-primary)' }}
                      />
                    </div>
                    
                    <div className="p-3 rounded-lg" style={{ backgroundColor: 'var(--card-bg)' }}>
                      <p className="text-sm font-semibold mb-2" style={{ color: 'var(--text-secondary)' }}>Template will save:</p>
                      <div className="text-xs space-y-1" style={{ color: 'var(--text-muted)' }}>
                        <div>🎯 Campaign: {selectedFoodItems[0]?.name}</div>
                        <div>📝 Content: {selectedImageType?.name}</div>
                        <div>🎨 Style: {selectedDesignStyle?.name}</div>
                        {showCustomization && <div>⚙️ Customization settings included</div>}
                        {manualPrompt && <div>✍️ Custom Instructions: "{manualPrompt.substring(0, 50)}{manualPrompt.length > 50 ? '...' : ''}"</div>}
                        <div>🏷️ Include Brand: {includeBrand ? 'Yes' : 'No'}</div>
                        <div>🎨 Brand colors: {user.brand_primary_color || 'Not set'}</div>
                        <div>🔤 Font: {user.brand_font_style || 'Default'}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex gap-3 mt-6">
                    <button
                      onClick={() => setShowSaveTemplateModal(false)}
                      className="flex-1 px-4 py-2 rounded-lg border transition"
                      style={{ borderColor: 'var(--border-color)', color: 'var(--text-secondary)' }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={saveTemplate}
                      className="flex-1 px-4 py-2 rounded-lg accent-gradient text-white transition"
                    >
                      Save Template
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* NEW Step 1: Campaign Type - 20 Types - COLLAPSIBLE */}
            <div className="theme-card border rounded-xl p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-center accent-text flex items-center flex-1 justify-center">
                  <span className="mr-2">🎯</span>
                  Step 1: Campaign Type
                  {selectedFoodItems.length > 0 && (
                    <span className="ml-3 text-sm px-3 py-1 rounded-full flex items-center gap-1" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                      ✓ {selectedFoodItems[0]?.name}
                    </span>
                  )}
                </h3>
                <button
                  onClick={() => setCollapseStep1(!collapseStep1)}
                  className="p-2 rounded-lg hover:bg-opacity-20 transition"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  <span className="text-2xl">{collapseStep1 ? '▼' : '▲'}</span>
                </button>
              </div>
              
              {/* Main Campaign Types - Smaller, Centered - All 20 Types */}
              {!collapseStep1 && (
                <div className="max-w-5xl mx-auto">
                  <p className="text-sm mb-3 text-center" style={{ color: 'var(--text-muted)' }}>Select your campaign type:</p>
                  <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
                    {contentCategories.campaign.items.map((item) => {
                      const isSelected = selectedFoodItems.some(f => f.id === item.id && f.name === item.name);
                      return (
                        <button
                          key={item.id}
                          onClick={() => {
                            setSelectedCuisine(contentCategories.campaign);
                            setSelectedFoodItems([item]); // Select this campaign type
                            setSelectedImageType(null);
                            setSelectedDesignStyle(null);
                          }}
                          className={`relative p-2 rounded-lg border-2 transition text-center ${
                            isSelected ? 'accent-gradient text-white' : 'theme-card-nested'
                          }`}
                          style={{
                            borderColor: isSelected ? 'transparent' : 'var(--border-color)',
                            color: isSelected ? '#ffffff' : 'var(--text-secondary)'
                          }}
                        >
                          {/* Tick mark on selected button */}
                          {isSelected && (
                            <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] font-bold" style={{ backgroundColor: '#10b981' }}>
                              ✓
                            </div>
                          )}
                          <div className="text-base mb-0.5">{item.icon}</div>
                          <div className="text-[10px] font-semibold leading-tight">{item.name}</div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* NEW Step 2: Content Type - 20 Types - COLLAPSIBLE */}
            {selectedFoodItems.length > 0 && (
              <div className="theme-card border rounded-xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-center accent-text flex items-center flex-1 justify-center">
                    <span className="mr-2">📝</span>
                    Step 2: Content Type
                    {selectedImageType && (
                      <span className="ml-3 text-sm px-3 py-1 rounded-full flex items-center gap-1" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                        ✓ {selectedImageType.name}
                      </span>
                    )}
                  </h3>
                  <button
                    onClick={() => setCollapseStep2(!collapseStep2)}
                    className="p-2 rounded-lg hover:bg-opacity-20 transition"
                    style={{ color: 'var(--text-secondary)' }}
                  >
                    <span className="text-2xl">{collapseStep2 ? '▼' : '▲'}</span>
                  </button>
                </div>
                
                {/* Content Type Options - 20 Types */}
                {!collapseStep2 && (
                  <div className="max-w-5xl mx-auto">
                    <p className="text-sm mb-3 text-center" style={{ color: 'var(--text-muted)' }}>Select content format:</p>
                    <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
                      {contentCategories.contentType.items.map((item) => {
                        const isSelected = selectedImageType?.id === item.id;
                        return (
                          <button
                            key={item.id}
                            onClick={() => {
                              setSelectedImageType(item);
                            }}
                            className={`relative p-2 rounded-lg border-2 transition text-center ${
                              isSelected ? 'accent-gradient text-white' : 'theme-card-nested'
                            }`}
                            style={{
                              borderColor: isSelected ? 'transparent' : 'var(--border-color)',
                              color: isSelected ? '#ffffff' : 'var(--text-secondary)'
                            }}
                          >
                            {/* Tick mark on selected button */}
                            {isSelected && (
                              <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] font-bold" style={{ backgroundColor: '#10b981' }}>
                                ✓
                              </div>
                            )}
                            <div className="text-base mb-0.5">{item.icon}</div>
                            <div className="text-[10px] font-semibold leading-tight">{item.name}</div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* NEW Step 3: Design Style - 20 Types - COLLAPSIBLE */}
            {selectedImageType && (
              <div className="theme-card border rounded-xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-center accent-text flex items-center flex-1 justify-center">
                    <span className="mr-2">🎨</span>
                    Step 3: Design Style
                    {selectedDesignStyle && (
                      <span className="ml-3 text-sm px-3 py-1 rounded-full flex items-center gap-1" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                        ✓ {selectedDesignStyle.name}
                      </span>
                    )}
                  </h3>
                  <button
                    onClick={() => setCollapseStep3(!collapseStep3)}
                    className="p-2 rounded-lg hover:bg-opacity-20 transition"
                    style={{ color: 'var(--text-secondary)' }}
                  >
                    <span className="text-2xl">{collapseStep3 ? '▼' : '▲'}</span>
                  </button>
                </div>
                
                {/* Design Style Options - 20 Types */}
                {!collapseStep3 && (
                  <div className="max-w-5xl mx-auto">
                    <p className="text-sm mb-3 text-center" style={{ color: 'var(--text-muted)' }}>Select design style:</p>
                    <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
                      {contentCategories.designStyle.items.map((item) => {
                        const isSelected = selectedDesignStyle?.id === item.id;
                        return (
                          <button
                            key={item.id}
                            onClick={() => {
                              setSelectedDesignStyle(item);
                            }}
                            className={`relative p-2 rounded-lg border-2 transition text-center ${
                              isSelected ? 'accent-gradient text-white' : 'theme-card-nested'
                            }`}
                            style={{
                              borderColor: isSelected ? 'transparent' : 'var(--border-color)',
                              color: isSelected ? '#ffffff' : 'var(--text-secondary)'
                            }}
                          >
                            {/* Tick mark on selected button */}
                            {isSelected && (
                              <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] font-bold" style={{ backgroundColor: '#10b981' }}>
                                ✓
                              </div>
                            )}
                            <div className="text-base mb-0.5">{item.icon}</div>
                            <div className="text-[10px] font-semibold leading-tight">{item.name}</div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}

          </>
        ) : (
          <>
            {/* === OTHER INDUSTRIES - ORIGINAL SYSTEM === */}
            {/* Content Category Selection - Dynamic based on Industry */}
            <div className="theme-card border rounded-xl p-6">
          <h3 className="text-xl font-bold mb-4 flex items-center justify-between accent-text">
            <span className="flex items-center">
              <span className="mr-2">🌍</span>
              Step 1: Select {categoryTitle.replace('Categories', 'Category')}
            </span>
            {selectedCuisine && (
              <span className="flex items-center gap-2 text-sm px-3 py-1 rounded-full" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                <span className="text-lg">✓</span>
                Completed
              </span>
            )}
          </h3>
          <p className="text-xs mb-3" style={{ color: 'var(--text-muted)' }}>Industry: <span className="accent-text font-semibold">{effectiveIndustry}</span></p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {Object.entries(contentCategories).map(([key, category]) => (
              <button
                key={key}
                onClick={() => {
                  setSelectedCuisine(category);
                  setSelectedFoodItems([]); // Reset item selection when changing category
                }}
                className={`p-4 rounded-lg border-2 transition text-center ${
                  selectedCuisine?.name === category.name
                    ? 'border-transparent accent-gradient'
                    : ''
                }`}
                style={selectedCuisine?.name !== category.name ? {
                  borderColor: 'var(--border-color)',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text-secondary)'
                } : { color: '#ffffff' }}
                onMouseEnter={(e) => {
                  if (selectedCuisine?.name !== category.name) {
                    e.currentTarget.style.borderColor = 'var(--accent-from)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedCuisine?.name !== category.name) {
                    e.currentTarget.style.borderColor = 'var(--border-color)';
                  }
                }}
              >
                <div className="text-3xl mb-2">{category.icon}</div>
                <div className="text-sm font-semibold">{category.name}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Content Items Selection (shows after category selection) - MULTIPLE SELECTION */}
        {selectedCuisine && (
          <div className="theme-card border rounded-xl p-6">
            <h3 className="text-xl font-bold mb-3 flex items-center justify-between accent-text">
              <span className="flex items-center">
                <span className="mr-2">{selectedCuisine.icon}</span>
                Step 2: Select {selectedCuisine.name} Items (Multiple Selection)
              </span>
              {selectedFoodItems.length > 0 && (
                <span className="flex items-center gap-2 text-sm px-3 py-1 rounded-full" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                  <span className="text-lg">✓</span>
                  {selectedFoodItems.length} Selected
                </span>
              )}
            </h3>
            <p className="text-xs mb-3" style={{ color: 'var(--text-muted)' }}>💡 Click multiple items to combine them in one image</p>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2">
              {selectedCuisine.items.map((item) => {
                const isSelected = selectedFoodItems.some(f => f.id === item.id);
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      if (isSelected) {
                        // Remove from selection
                        setSelectedFoodItems(selectedFoodItems.filter(f => f.id !== item.id));
                      } else {
                        // Add to selection
                        setSelectedFoodItems([...selectedFoodItems, item]);
                      }
                    }}
                    className={`p-3 rounded-lg border-2 transition text-center relative ${
                      isSelected
                        ? 'border-transparent accent-gradient'
                        : ''
                    }`}
                    style={!isSelected ? {
                      borderColor: 'var(--border-color)',
                      backgroundColor: 'var(--card-bg)',
                      color: 'var(--text-secondary)'
                    } : { color: '#ffffff' }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.borderColor = 'var(--accent-from)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.borderColor = 'var(--border-color)';
                      }
                    }}
                  >
                    {isSelected && (
                      <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-white text-xs font-bold" style={{ backgroundColor: 'var(--accent-from)' }}>
                        ✓
                      </div>
                    )}
                    <div className="text-xs font-semibold">{item.name}</div>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Image Style Section - Industry-Specific - Compact One-Line */}
        <div className="theme-card border rounded-xl p-4">
          <h3 className="text-lg font-bold mb-3 flex items-center justify-between accent-text">
            <span className="flex items-center">
              <span className="mr-2">📸</span>
              Step 3: Select Image Style
              <span className="ml-2 text-xs text-purple-400">({effectiveIndustry})</span>
            </span>
            {selectedImageType && (
              <span className="flex items-center gap-2 text-sm px-3 py-1 rounded-full" style={{ backgroundColor: '#10b981', color: '#ffffff' }}>
                <span className="text-lg">✓</span>
                Completed
              </span>
            )}
          </h3>
          <div className="grid grid-cols-6 gap-2">
            {industryImageStyles.map((type) => (
              <button
                key={type.id}
                onClick={() => setSelectedImageType(type)}
                className={`p-2 rounded-lg border-2 transition text-center ${
                  selectedImageType?.id === type.id
                    ? 'border-transparent accent-gradient'
                    : ''
                }`}
                style={selectedImageType?.id !== type.id ? {
                  borderColor: 'var(--border-color)',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text-secondary)'
                } : { color: '#ffffff' }}
                onMouseEnter={(e) => {
                  if (selectedImageType?.id !== type.id) {
                    e.currentTarget.style.borderColor = 'var(--accent-from)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedImageType?.id !== type.id) {
                    e.currentTarget.style.borderColor = 'var(--border-color)';
                  }
                }}
                title={type.style}
              >
                <div className="text-2xl mb-1">{type.icon}</div>
                <div className="text-[10px] font-semibold leading-tight">{type.name}</div>
              </button>
            ))}
          </div>
        </div>
          </>
        )}

        {/* Additional Features Section - Dynamic based on industry - WITH TOGGLE AND COLLAPSE */}
        <div className="theme-card border rounded-xl p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-bold flex items-center accent-text">
              <span className="mr-2">⚙️</span>
              Step 4: Customize Details (Optional)
            </h3>
            <div className="flex items-center gap-2">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={showCustomization}
                  onChange={(e) => setShowCustomization(e.target.checked)}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 peer-focus:outline-none peer-focus:ring-4 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all" style={{ backgroundColor: showCustomization ? 'var(--accent-from)' : 'var(--border-color)' }}></div>
                <span className="ml-2 text-sm" style={{ color: 'var(--text-muted)' }}>{showCustomization ? 'Enabled' : 'Disabled'}</span>
              </label>
              {showCustomization && (
                <button
                  onClick={() => setCollapseStep4(!collapseStep4)}
                  className="p-2 rounded-lg hover:bg-opacity-20 transition"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  <span className="text-2xl">{collapseStep4 ? '▼' : '▲'}</span>
                </button>
              )}
            </div>
          </div>
          
          {showCustomization && !collapseStep4 && (
          <>
          
          {/* Scale/Size Option */}
          <div className="mb-4">
            <h4 className="text-sm font-semibold text-blue-300 mb-2">Scale/Size</h4>
            <div className="grid grid-cols-3 gap-2">
              {industryCustomization.scale.map((scale) => (
                <button
                  key={scale.id}
                  onClick={() => setSelectedScale(scale)}
                  className={`p-3 rounded-lg border-2 transition ${
                    selectedScale?.id === scale.id
                      ? 'border-blue-500 bg-blue-500/20 text-blue-300'
                      : 'border-gray-700 bg-gray-800/50 text-gray-300 hover:border-blue-500/50'
                  }`}
                >
                  <div className="text-2xl mb-1">{scale.icon}</div>
                  <div className="text-xs font-semibold">{scale.name}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Angle/Presentation */}
          <div className="mb-4">
            <h4 className="text-sm font-semibold text-green-300 mb-2">Angle/Presentation</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {industryCustomization.angle.map((angle) => (
                <button
                  key={angle.id}
                  onClick={() => setSelectedAngle(angle)}
                  className={`p-3 rounded-lg border-2 transition ${
                    selectedAngle?.id === angle.id
                      ? 'border-green-500 bg-green-500/20 text-green-300'
                      : 'border-gray-700 bg-gray-800/50 text-gray-300 hover:border-green-500/50'
                  }`}
                >
                  <div className="text-2xl mb-1">{angle.icon}</div>
                  <div className="text-xs font-semibold">{angle.name}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Extras/Props - MULTIPLE SELECTION */}
          <div>
            <h4 className="text-sm font-semibold text-yellow-300 mb-2 flex items-center justify-between">
              <span>Extras & Props (Multiple Selection)</span>
              {selectedExtras.length > 0 && (
                <span className="text-xs bg-yellow-500/20 text-yellow-300 px-2 py-1 rounded-full">
                  {selectedExtras.length} selected
                </span>
              )}
            </h4>
            <p className="text-xs text-gray-400 mb-2">💡 Select multiple options to combine</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {industryCustomization.extras.map((extra) => {
                const isSelected = selectedExtras.some(e => e.id === extra.id);
                return (
                  <button
                    key={extra.id}
                    onClick={() => {
                      if (isSelected) {
                        // Remove from selection (keep at least one)
                        if (selectedExtras.length > 1) {
                          setSelectedExtras(selectedExtras.filter(e => e.id !== extra.id));
                        }
                      } else {
                        // Add to selection
                        setSelectedExtras([...selectedExtras, extra]);
                      }
                    }}
                    className={`p-3 rounded-lg border-2 transition relative ${
                      isSelected
                        ? 'border-yellow-500 bg-yellow-500/20 text-yellow-300'
                        : 'border-gray-700 bg-gray-800/50 text-gray-300 hover:border-yellow-500/50'
                    }`}
                  >
                    {isSelected && (
                      <div className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
                        ✓
                      </div>
                    )}
                    <div className="text-2xl mb-1">{extra.icon}</div>
                    <div className="text-xs font-semibold">{extra.name}</div>
                  </button>
                );
              })}
            </div>
          </div>
          </>
          )}
        </div>

        {/* AI Prompt Preview & Edit - COLLAPSIBLE */}
        <div className="theme-card border rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold flex items-center accent-text">
              <span className="mr-2">✍️</span>
              Step 5: AI Prompt (Preview & Edit)
            </h3>
            <div className="flex items-center gap-2">
              {promptEdited && (
                <button
                  data-testid="reset-prompt-btn"
                  onClick={() => { setPromptEdited(false); }}
                  className="px-3 py-1 rounded-lg text-xs font-medium transition"
                  style={{ background: 'rgba(239,68,68,0.15)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.3)' }}
                >
                  Reset to Auto
                </button>
              )}
              <button
                onClick={() => setCollapseStep5(!collapseStep5)}
                className="p-2 rounded-lg hover:bg-opacity-20 transition"
                style={{ color: 'var(--text-secondary)' }}
              >
                <span className="text-2xl">{collapseStep5 ? '▼' : '▲'}</span>
              </button>
            </div>
          </div>
          {!collapseStep5 && (
            <>
              {manualPrompt ? (
                <textarea
                  data-testid="ai-prompt-textarea"
                  value={manualPrompt}
                  onChange={(e) => { setManualPrompt(e.target.value); setPromptEdited(true); }}
                  className="theme-input w-full h-32 border rounded-lg px-4 py-3 focus:outline-none resize-y text-sm"
                  style={{ 
                    borderColor: promptEdited ? '#f59e0b' : 'var(--accent-from)',
                    background: promptEdited ? 'rgba(245,158,11,0.05)' : undefined
                  }}
                />
              ) : (
                <div className="w-full h-24 border rounded-lg px-4 py-3 flex items-center justify-center text-sm" style={{ borderColor: 'var(--input-border)', color: 'var(--text-muted)', borderStyle: 'dashed' }}>
                  Select items and image style above to see the AI prompt
                </div>
              )}
              <p className="text-xs mt-2" style={{ color: 'var(--text-muted)' }}>
                {promptEdited 
                  ? 'You edited this prompt. Click "Reset to Auto" to regenerate from your selections.' 
                  : 'This prompt is auto-generated from your selections. Edit it freely to customize the AI output.'}
              </p>
            </>
          )}
        </div>

        {/* Brand Integration - Smart Detection from Settings - COLLAPSIBLE */}
        <div className="theme-card border rounded-xl p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-bold flex items-center accent-text">
              <span className="mr-2">🏷️</span>
              Step 6: Brand Integration
            </h3>
            <button
              onClick={() => setCollapseStep6(!collapseStep6)}
              className="p-2 rounded-lg hover:bg-opacity-20 transition"
              style={{ color: 'var(--text-secondary)' }}
            >
              <span className="text-2xl">{collapseStep6 ? '▼' : '▲'}</span>
            </button>
          </div>
          
          {!collapseStep6 && (
            <div>
          
          {user.brand_name ? (
            <div className="space-y-3">
              {/* Brand Settings Detected */}
              <div className="border rounded-lg p-3" style={{ 
                backgroundColor: 'rgba(34, 197, 94, 0.1)', 
                borderColor: 'rgba(34, 197, 94, 0.3)' 
              }}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center space-x-2">
                    <span className="text-green-400">✓</span>
                    <span className="text-sm font-semibold text-green-400">Brand Settings Detected</span>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={includeBrand}
                      onChange={(e) => setIncludeBrand(e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 peer-focus:outline-none peer-focus:ring-4 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all" style={{ backgroundColor: includeBrand ? 'var(--accent-from)' : 'var(--border-color)' }}></div>
                    <span className="ml-2 text-sm" style={{ color: 'var(--text-muted)' }}>{includeBrand ? 'Enabled' : 'Disabled'}</span>
                  </label>
                </div>
                
                {includeBrand && (
                  <div className="text-xs space-y-1 pl-6" style={{ color: 'var(--text-secondary)' }}>
                    <div>📛 Brand: <span className="accent-text font-semibold">{user.brand_name}</span></div>
                    <div>🎨 Mode: <span className="accent-text capitalize">{(user.brand_scene_mode || 'text_only').replace('_', ' ')}</span></div>
                    {user.brand_scene_logo && (
                      <div>🖼️ Logo: <span className="text-green-400">Uploaded ✓</span></div>
                    )}
                    {!user.brand_scene_logo && (user.brand_scene_mode === 'logo_only' || user.brand_scene_mode === 'text_and_logo') && (
                      <div className="text-yellow-400">⚠️ Logo mode selected but no logo uploaded</div>
                    )}
                    <div className="text-blue-400 mt-2">
                      💡 Using settings from Settings → Brand
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="border rounded-lg p-3" style={{ 
              backgroundColor: 'rgba(234, 179, 8, 0.1)', 
              borderColor: 'rgba(234, 179, 8, 0.3)' 
            }}>
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-yellow-400">⚠️</span>
                <span className="text-sm font-semibold text-yellow-400">No Brand Configured</span>
              </div>
              <p className="text-xs mb-3" style={{ color: 'var(--text-muted)' }}>Set up your brand to automatically include it in AI images</p>
              <button
                onClick={() => {
                  // Suggest user to go to settings
                  alert('Please go to Settings → Brand tab to configure your brand name, colors, and logo.');
                }}
                className="text-xs px-3 py-1.5 bg-yellow-600 hover:bg-yellow-700 text-white rounded transition"
              >
                → Go to Settings
              </button>
            </div>
          )}
          {/* Platform/Size Selector */}
          <div className="max-w-4xl mx-auto mb-6">
            <label className="block font-semibold mb-3 text-center accent-text">
              📐 Select Platform/Size
            </label>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
              {[
                { value: 'square', label: 'Square', size: '1:1', platform: 'IG/FB', icon: '⬜' },
                { value: 'instagram_portrait', label: 'IG Portrait', size: '4:5', platform: '1080x1350', icon: '📱' },
                { value: 'instagram_story', label: 'IG Story', size: '9:16', platform: '1080x1920', icon: '📲' },
                { value: 'facebook_post', label: 'FB Post', size: '1.91:1', platform: '1200x630', icon: '📘' },
                { value: 'twitter_post', label: 'Twitter', size: '16:9', platform: '1200x675', icon: '🐦' },
                { value: 'linkedin_post', label: 'LinkedIn', size: '1.91:1', platform: '1200x627', icon: '💼' },
                ...(effectiveIndustry === 'Food & Restaurant' ? [
                  { value: 'uber_eats_dish', label: 'Uber Eats', size: '1:1', platform: '1200x1200', icon: '🍔' },
                  { value: 'doordash_item', label: 'DoorDash', size: '16:9', platform: '1400x788', icon: '🚗' },
                  { value: 'grubhub_item', label: 'Grubhub', size: '3:2', platform: '1200x800', icon: '🛵' },
                  { value: 'zomato_swiggy_dish', label: 'Zomato/Swiggy', size: '1:1', platform: '1080x1080', icon: '🍽️' },
                  { value: 'delivery_cover', label: 'Delivery Cover', size: '16:9', platform: '1920x1080', icon: '🖼️' }
                ] : [])
              ].map((size) => (
                <button
                  key={size.value}
                  data-testid={`image-size-${size.value}`}
                  onClick={() => setImageSize(size.value)}
                  className={`p-3 rounded-lg border-2 transition text-center ${
                    imageSize === size.value
                      ? 'border-transparent accent-gradient'
                      : ''
                  }`}
                  style={imageSize !== size.value ? {
                    borderColor: 'var(--border-color)',
                    backgroundColor: 'var(--card-bg)',
                    color: 'var(--text-muted)'
                  } : { color: '#ffffff' }}
                  onMouseEnter={(e) => {
                    if (imageSize !== size.value) {
                      e.currentTarget.style.borderColor = 'var(--accent-from)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (imageSize !== size.value) {
                      e.currentTarget.style.borderColor = 'var(--border-color)';
                    }
                  }}
                >
                  <div className="text-2xl mb-1">{size.icon}</div>
                  <div className="text-xs font-semibold">{size.label}</div>
                  <div className="text-[10px]" style={{ color: 'var(--text-muted)' }}>{size.size}</div>
                </button>
              ))}
            </div>
          </div>
          </div>
          )}
        </div>

        {/* Generate Button */}
        <div className="flex flex-col items-center gap-3">
          {/* Selection Summary */}
          {selectedFoodItems.length > 0 && selectedImageType && (
            <div className="theme-card-nested border rounded-lg px-6 py-3 text-sm max-w-4xl" style={{ color: 'var(--text-secondary)' }}>
              <span className="font-semibold accent-text">Ready to generate: </span>
              {effectiveIndustry === 'Digital Marketing' ? (
                <>
                  {selectedFoodItems[0].name} Campaign • {selectedImageType.name}
                  {selectedDesignStyle && ` • ${selectedDesignStyle.name} Style`}
                  {showCustomization && ` • ${selectedScale.name} • ${selectedAngle.name} • ${selectedExtras.map(e => e.name).join(', ')}`}
                  {manualPrompt && ` • Custom: ${manualPrompt.substring(0, 50)}${manualPrompt.length > 50 ? '...' : ''}`}
                  {includeBrand && user.brand_name && ` • Brand: ${user.brand_name}`}
                </>
              ) : (
                <>
                  {selectedCuisine.name} ({selectedFoodItems.map(f => f.name).join(', ')}) • {selectedImageType.name} style
                  {showCustomization && ` • ${selectedScale.name} • ${selectedAngle.name} • ${selectedExtras.map(e => e.name).join(', ')}`}
                  {manualPrompt && ` • Custom: ${manualPrompt.substring(0, 50)}${manualPrompt.length > 50 ? '...' : ''}`}
                  {includeBrand && user.brand_name && ` • Brand: ${user.brand_name}`}
                </>
              )}
            </div>
          )}
          
          <button
            onClick={generateContentImage}
            disabled={selectedFoodItems.length === 0 || !selectedImageType || loading}
            className="px-10 py-5 accent-gradient text-white text-xl font-bold rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed shadow-2xl transform hover:scale-105"
          >
            {loading ? (
              <span className="flex items-center">
                <svg className="animate-spin h-6 w-6 mr-3" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                </svg>
                Generating Magic Image...
              </span>
            ) : (
              '✨ Generate AI Magic Image'
            )}
          </button>
          
          {selectedFoodItems.length === 0 && !selectedImageType && (
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Please select category, items, and image style to continue</p>
          )}
        </div>

        {/* Error Display */}
        {error && (
          <div className="bg-red-900/20 border border-red-500/50 rounded-lg p-4 text-red-300 text-sm">
            {error}
          </div>
        )}
      </div>

      {/* Image Preview Modal */}
      {showPreview && previewData && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 border-2 border-orange-500/50 rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
            <div className="bg-gradient-to-r from-orange-500/20 to-amber-500/20 border-b border-orange-500/30 px-6 py-4">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-white">🖼️ AI Image Preview</h3>
                <button
                  onClick={() => setShowPreview(false)}
                  className="text-gray-400 hover:text-white transition"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6">
              <img
                src={previewData.image}
                alt="Generated"
                className="w-full rounded-lg shadow-lg mb-4"
              />
              
              {/* Technical Details */}
              <div className="bg-gray-800/50 rounded-lg p-3 mb-4">
                <p className="text-gray-400 text-sm text-left whitespace-pre-line">{previewData.caption}</p>
              </div>
              
              {/* AI Caption Section */}
              {aiCaption && (
                <div className="bg-gradient-to-r from-orange-500/10 to-amber-500/10 border border-orange-500/30 rounded-lg p-4 mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-sm font-semibold text-orange-400">✨ AI Generated Caption</h4>
                    <button
                      onClick={() => setAiCaption('')}
                      className="text-gray-400 hover:text-white text-xs"
                    >
                      Clear
                    </button>
                  </div>
                  <textarea
                    value={aiCaption}
                    onChange={(e) => setAiCaption(e.target.value)}
                    className="w-full bg-gray-900/50 border border-gray-700 rounded-lg p-3 text-gray-200 text-sm text-left focus:outline-none focus:border-orange-500 resize-none"
                    rows="4"
                    placeholder="AI caption will appear here..."
                  />
                </div>
              )}
              
              <div className="flex flex-col gap-3">
                {/* Write AI Content Button */}
                {!aiCaption && (
                  <button
                    onClick={generateAICaption}
                    disabled={generatingCaption}
                    className="w-full px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-lg font-medium hover:from-orange-600 hover:to-amber-600 transition disabled:opacity-50 flex items-center justify-center gap-2"
                  >
                    {generatingCaption ? (
                      <>⏳ Generating Caption...</>
                    ) : (
                      <>✨ Write AI Content</>
                    )}
                  </button>
                )}
                
                {/* Action Buttons */}
                <div className="flex flex-col gap-3">
                  <div className="flex gap-3">
                    <button
                      onClick={savePostToGallery}
                      disabled={loading}
                      className="flex-1 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg font-medium hover:from-green-600 hover:to-emerald-600 transition disabled:opacity-50"
                    >
                      {loading ? 'Saving...' : '💾 Save as Post'}
                    </button>
                    <button
                      onClick={() => setShowPreview(false)}
                      className="px-6 py-3 bg-gray-700 text-white rounded-lg font-medium hover:bg-gray-600 transition"
                    >
                      Close
                    </button>
                  </div>
                  
                  {/* Save as Template Button - Only for Digital Marketing */}
                  {effectiveIndustry === 'Digital Marketing' && previewData?.savedSelections && (
                    <button
                      onClick={() => {
                        // Use saved selections from previewData
                        const saved = previewData.savedSelections;
                        if (saved.campaignType && saved.contentType && saved.designStyle) {
                          // Temporarily restore selections for saving
                          setSelectedFoodItems([saved.campaignType]);
                          setSelectedImageType(saved.contentType);
                          setSelectedDesignStyle(saved.designStyle);
                          if (saved.customizationEnabled) {
                            setShowCustomization(true);
                            setSelectedScale(saved.customization.scale);
                            setSelectedAngle(saved.customization.angle);
                            setSelectedExtras(saved.customization.extras);
                          }
                          // Restore manual prompt and brand toggle
                          if (saved.manualPrompt !== undefined) {
                            setManualPrompt(saved.manualPrompt);
                          }
                          if (saved.includeBrand !== undefined) {
                            setIncludeBrand(saved.includeBrand);
                          }
                          setShowPreview(false);
                          setShowSaveTemplateModal(true);
                        } else {
                          alert('⚠️ Unable to save template - selection data missing');
                        }
                      }}
                      className="w-full px-6 py-3 accent-gradient text-white rounded-lg font-medium transition hover:opacity-90 flex items-center justify-center gap-2"
                    >
                      <span>⭐</span>
                      <span>Save This Combination as Template</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AIMagicSection;
